<template>
<div>
    <!-- Error Toast -->
    <div v-if="toastMessage" class="error-toast">
        <span>{{ toastMessage }}</span>
        <button class="toast-close" @click="toastMessage = ''">&times;</button>
    </div>

    <!-- Loading state -->
    <div v-if="initilizingCart">
        <blurryLoader />
    </div>

    <!-- Priority Physician Review — offered once the order is captured, charged
         separately. Declining or failing here cannot touch the paid order; either
         answer continues to the same confirmation page. -->
    <fast-track-upsell-modal
        v-if="fastTrackOfferOpen && fastTrackAddon"
        :addon="fastTrackAddon"
        :payment-method="paymentInfo.paymentMethod || 'card'"
        :base-url="baseUrl"
        :user-id="paymentInfo.user_id || (user && user.id) || ''"
        :first-name="(user && user.first_name) || ''"
        :last-name="(user && user.last_name) || ''"
        :email="(user && user.email) || ''"
        :shipping-address="customerInfo"
        :tracking-session-id="trackingSessionId"
        :ip-address="ip_address"
        @close="closeFastTrackOffer"
    />

    <!-- Processing payment popup. Hidden while the add-on offer is up: the charge
         that spinner belongs to has already succeeded. -->
    <div v-if="submitted && !fastTrackOfferOpen" class="loading-overlay2">
            <div class="">
                <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <circle cx="50" cy="50" fill="none" stroke="#52b2cf" stroke-width="10" r="35" stroke-dasharray="165 57">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                </circle>
                </svg>
            </div>
        </div>
    <!-- Logo header section -->
     <div class="error_popup popup-desktop" v-if="addressError" style="display:block; z-index: 9999; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5);justify-content:center;">
        <div class="error_box error-pop-desk" style="display:flex;justify-content:center;">
            <img src="@/assets/images/icon_Urgent.svg" loading="lazy" alt="" class="image-496">
            <div class="text-block-1101">Invalid Address</div>
            <div class="text-block-1102" style="display:flex;justify-content:center;text-align: center;">FedEx and UPS our carriers do not deliver to P.O. Box addresses. Please enter a valid street address.</div>
            <div class="text-block-1102">
                <a href="#" @click.prevent="addressError=false;" class="submit-button-3 new w-button"  style="color:#fff;margin-top: 0px;margin-bottom: 0px;">Update Address</a>
            </div>
        </div>
    </div>
    <section class="section_logo-bar">
        <div class="logonav_wrap">
            <div class="logonav_div">
                <a href="#" class="link-block-73 w-inline-block">
                    <img sizes="(max-width: 2083px) 100vw, 2083px" srcset="@/assets/images/_Rx-Pros-Logo-01-p-500.png 500w, 
                           @/assets/images/_Rx-Pros-Logo-01-p-800.png 800w, 
                           @/assets/images/_Rx-Pros-Logo-01-p-1080.png 1080w, 
                           @/assets/images/_Rx-Pros-Logo-01.png 2083w" alt="" src="@/assets/images/_Rx-Pros-Logo-01.png" loading="lazy" class="image-487">
                </a>
                <div class="logonav_progressdiv">
                    <div class="progress_step_div"></div>
                    <div class="progress_step_div current"></div>
                    <div class="progress_step_div"></div>
                    <div class="progress_step_div"></div>
                </div>
            </div>
        </div>
    </section>

    <!-- Main checkout section -->
    <section class="checkout-section">
        <div class="checkoutb_wrap-6">
            <!-- Payment plan selection -->
            <div class="checkout-part-1">
                <div class="checkout-plans-div">
                    <div class="w-form">
                        <form id="email-form-2" name="email-form-2" data-name="Email Form 2" method="get" class="form_planselect">
                            <div class="plan-options-div">
                                <div class="select-plan-text payplan-header checkout3">Select Payment Plan:</div>
                                <div class="text-block-1447 checkout3">The longer you commit, <span class="text-span-302">the less you pay</span></div>
                                <div class="bullets-div">
                                <div class="bullets-flex">
                                    <div class="bullet-point"><img src="@/assets/images/icon_Dollar_blk.svg" loading="lazy" alt="" class="image-603 _1">
                                    <div class="text-block-1509"><strong>All Dosages Same price</strong></div>
                                    </div>
                                    <div class="bullet-point"><img src="@/assets/images/icon_Pricetrophy_blk.svg" loading="lazy" alt="" class="image-603">
                                    <div class="text-block-1509"><strong>Everything Included</strong></div>
                                    </div>
                                </div>
                                <div class="bullets-flex">
                                    <div class="bullet-point"><img src="@/assets/images/icon_PM_No-Price-Increase_blk.png" loading="lazy" alt="" class="image-603">
                                    <div class="text-block-1509"><strong>No Price Increases</strong></div>
                                    </div>
                                    <div class="bullet-point"><img src="@/assets/images/icon_savings_blk.svg" loading="lazy" alt="" class="image-603">
                                    <div class="text-block-1509"><strong>No Membership Fees</strong></div>
                                    </div>
                                </div>
                                </div>
                                <!-- Monthly plan option -->
                                <a @click.prevent="paymentInfo.payment_terms = 1" :class="{'active-one': paymentInfo.payment_terms === 1}" href="#" class="plan-box-link w-inline-block">
                                    <div class="plan-box-div">
                                        <div class="planbox_txtdiv">
                                            <div class="div-block-2098">
                                                <div class="text-block-1437">Monthly Plan</div>
                                            </div>
                                            <div class="text-block-1440">${{ getFirstMonthPrice().toFixed(2) }} a month for 3 months<br>3 month supply paid monthly<br><strong>Industry Low Pricing</strong></div>
                                        </div>
                                    </div>
                                    <div class="planbox_pricebox">
                                        <div class="planbox_pricediv">
                                            <div class="text-block-1448">$</div>
                                            <div class="text-block-1438">{{ Math.floor(getFirstMonthPrice()) }}</div>
                                            <div class="text-block-1449">.{{ (getFirstMonthPrice() % 1).toFixed(2).substring(2) }}</div>
                                        </div>
                                        <div class="text-block-1439"> A Month </div>
                                    </div>
                                </a>

                                <!-- 3-Month plan option -->
                                <a @click.prevent="paymentInfo.payment_terms = 3" :class="{'active-me': paymentInfo.payment_terms === 3}" href="#" class="plan-box-link _3mo w-inline-block">
                                    <div class="plan-box-div">
                                        <div class="planbox_txtdiv">
                                            <div class="div-block-2098">
                                                <div class="text-block-1437">3-Month Plan</div>
                                            </div>
                                            <div class="text-block-1440">${{ getMonthlyPrice(3).toFixed(2) }} / Month<br>${{ getTotalPrice(3).toFixed(2) }} Total for 3 Months<br><strong>${{ calculateSavings(3).toFixed(2) }} Total Savings</strong></div>
                                        </div>
                                    </div>
                                    <div class="planbox_pricebox">
                                        <div class="planbox_pricediv">
                                            <div>$</div>
                                            <div class="text-block-1438">{{ Math.floor(getMonthlyPrice(3)) }}</div>
                                            <div>.{{ (getMonthlyPrice(3) % 1).toFixed(2).substring(2) }}</div>
                                        </div>
                                        <div class="text-block-1439">Monthly Avg.</div>
                                    </div>
                                </a>

                                <!-- 6-Month plan option -->
                                <a @click.prevent="paymentInfo.payment_terms = 6" :class="{'active-six': paymentInfo.payment_terms === 6}" href="#" class="plan-box-link _6mo w-inline-block">
                                    <span class="plan-badge plan-badge--popular">Popular</span>
                                    <div class="plan-box-div">
                                        <div class="planbox_txtdiv">
                                            <div class="div-block-2098">
                                                <div class="text-block-1437">6-Month Plan</div>
                                                <div class="planbox_pricebox _6mo">
                                                    <div class="planbox_pricediv">
                                                        <div>$</div>
                                                        <div class="text-block-1438">{{ Math.floor(getMonthlyPrice(6)) }}</div>
                                                        <div>.{{ (getMonthlyPrice(6) % 1).toFixed(2).substring(2) }}</div>
                                                    </div>
                                                    <div class="text-block-1439">Monthly Avg.</div>
                                                </div>
                                            </div>
                                            <div class="text-block-1440">${{ getTotalPrice(6).toFixed(2) }} Total 6 Months<br>3 Vials Every 90 Days<br><strong>${{ calculateSavings(6).toFixed(2) }} Total Savings</strong></div>
                                        </div>
                                    </div>
                                </a>

                                <a @click.prevent="paymentInfo.payment_terms = 12" :class="{'active-six': paymentInfo.payment_terms === 12}" href="#" class="plan-box-link _6mo _12mo w-inline-block">
                                    <span class="plan-badge plan-badge--recommended">Recommended</span>
                                    <div class="plan-box-div">
                                        <div class="planbox_txtdiv">
                                            <div class="div-block-2098">
                                                <div class="text-block-1437">12-Month Plan</div>
                                                <div class="planbox_pricebox _6mo">
                                                    <div class="planbox_pricediv">
                                                        <div>$</div>
                                                        <div class="text-block-1438">{{ Math.floor(getMonthlyPrice(12)) }}</div>
                                                        <div>.{{ (getMonthlyPrice(12) % 1).toFixed(2).substring(2) }}</div>
                                                    </div>
                                                    <div class="text-block-1439">Monthly Avg.</div>
                                                    <span class="huge-savings-btn">Huge Savings</span>
                                                </div>
                                            </div>
                                            <div class="text-block-1440">${{ getTotalPrice(12).toFixed(2) }} Total 12 Months<br>3 Vials Every 90 Days<br><strong>${{ calculateSavings(12).toFixed(2) }} Total Savings</strong></div>
                                        </div>
                                    </div>
                                </a>
                            </div>

                            <!-- Treatment plan review section -->
                            <div class="plan-review-div">
                                <div class="text-block-1064">2. Review Plan</div>
                                <div class="text-block-1447 checkout3">No surprises or upcharges. <br/><span class="myspanret">All Dosages are the same price!</span></div>

                                <!-- Monthly plan review section -->
                                <div class="checkout_planbox monthly" v-if="paymentInfo.payment_terms === 1" style="display:block">
                                    <div class="planbox_div1">
                                        <div class="plan_div monthly">
                                            <div class="plandetails_div">
                                                <img sizes="(max-width: 1080px) 100vw, 1080px" :srcset="getImage" alt="" :src="getImage" loading="lazy" class="image-488 _1mo">
                                                <div class="planinfo-div">
                                                    <div class="infotop">
                                                        <div class="plannameplantype info-top">
                                                            <div class="text-block-1066 myclsforse">{{ getcartItems.name }}</div>
                                                            <div class="text-block-1067">MONTHLY PLAN</div>
                                                        </div>
                                                        <div class="plandosage_div">
                                                            <div class="text-block-1068" v-if="getcartItems.name==='Tirzepatide'">Compounded w/ B6 (Pyridoxine)</div>
                                                            <div class="text-block-1068" v-else>Compounded w/ B12 (Cyanocobalamin)</div>
                                                         </div>
                                                        
                                                    </div>
                                                    <div class="text-block-1070">3-Month Supply - All Dosage Levels</div>
                                                </div>
                                            </div>
                                            <div class="text-block-1071 myclsforse">${{ getRegularMonthlyPrice().toFixed(2) }}</div>
                                        </div>
                                        <cart-offer-row v-if="offerLineActive" :offer="cartOffer" :terms="paymentInfo.payment_terms" tile-class="_1mo" />
                                        <div>
                                            <ul role="list" class="list-14">
                                                <li v-for="(point, index) in getPlanPoints" :key="index" class="list-item-14">
                                                    <div class="text-block-1445">{{ point.header }}</div>
                                                    <div>{{ point.sub_header }}</div>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="plandiscount-div" v-if="paymentInfo.discount>0">
                                            <div class="discounttype_div">
                                                <div class="text-block-1072">PROMO ${{ getMonthlyDiscount().toFixed(2) }} OFF</div>
                                            </div>
                                            <div class="dicountamount_div">
                                                <img loading="lazy" src="@/assets/images/icon_tag.svg" alt="" class="image-586">
                                                <div class="discount-text">-${{ getMonthlyDiscount().toFixed(2) }}</div>
                                            </div>
                                        </div>
                                        <div class="div-block-2102 checkout">
                                            <input class="text-field-62 coupon new w-input" v-model="couponInput" maxlength="256" name="field-3" data-name="Field 3" placeholder="Coupon Code" type="text" id="field-3" required="">
                                            <a href="#" @click.prevent="handleCouponSubmit" class="button-138 new w-button">Apply</a>
                                        </div>
                                    </div>
                                    <div class="planbox_div2">
                                        <div class="freebie_div">
                                            <div class="freebietypediv">
                                                <img loading="lazy" src="@/assets/images/icon_board-copy.svg" alt="" class="image-491">
                                                <div class="text-block-1073">Doctor Review &amp; Prescription</div>
                                            </div>
                                            <div class="discount-text free">INCLUDED</div>
                                        </div>
                                        <div class="freebie_div">
                                            <div class="freebietypediv">
                                                <img loading="lazy" src="@/assets/images/icon_support.svg" alt="" class="image-491">
                                                <div class="text-block-1073">Clinical Chat Support</div>
                                            </div>
                                            <div class="discount-text free">INCLUDED</div>
                                        </div>
                                        <!--<div class="freebie_div">
                                            <div class="freebietypediv">
                                                <img loading="lazy" src="@/assets/images/67480dcc3a63febc2e5185b2_icon_appointment.svg" alt="" class="image-491">
                                                <div class="text-block-1073">Monthly Check-ins</div>
                                            </div>
                                            <div class="discount-text free">INCLUDED</div>
                                        </div>-->
                                        <div class="freebie_div">
                                            <div class="freebietypediv">
                                                <img loading="lazy" src="@/assets/images/66f29c17a6c44f05de988c80_icon_shipping.svg" alt="" class="image-491">
                                                <div class="text-block-1073">Overnight Cold Shipping</div>
                                            </div>
                                            <div class="discount-text free">INCLUDED</div>
                                        </div>
                                    </div>
                                    <p style="font-size:8px;line-height:1;padding-top:1px;">*The clinician consultation fee is included in the program cost and is paid directly to our independent doctor network partners. This fee is processed regardless of whether you qualify for treatment or receive a prescription. If your consultation results in a denial, you will not be responsible for this payment.</p>
                                    <div class="planbox_div3">
                                        <div class="text-block-1076" v-if="paymentInfo.discount>0">You're Saving ${{ getMonthlyDiscount().toFixed(2) }}</div>
                                        <div class="plansubtotal_div">
                                            <div class="text-block-1075">Due Today</div>
                                            <div class="subtotalamount_div">
                                                <div class="text-block-1077">${{ displayTotal.toFixed(2) }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="text-block-1450">
                                        <a href="#" @click.prevent="$router.go(-1)" class="link-75"><span class="text-span-333">&lt;- </span>Go back to Selection</a>
                                    </div>
                                    <a @click="fireCheckoutTracking" href="#payment-section" class="button-139 w-button">Next: Complete Payment &gt;</a>
                                </div>

                                <!-- 3-Month plan review section -->
                                <div class="checkout_planbox _3months" v-if="paymentInfo.payment_terms === 3" style="display:block">
                                    <div class="planbox_div1">
                                        <div class="plan_div monthly">
                                            <div class="plandetails_div">
                                                <img sizes="(max-width: 1080px) 100vw, 1080px" :srcset="getImage" alt="" :src="getImage" loading="lazy" class="image-488 _3months">
                                                <div class="planinfo-div">
                                                    <div class="infotop">
                                                        <div class="plannameplantype info-top">
                                                            <div class="text-block-1066 myclsforse">{{ getcartItems.name }}</div>
                                                            <div class="text-block-1067">3-MONTH PLAN</div>
                                                        </div>
                                                        <div class="plandosage_div">
                                                            <div class="text-block-1068" v-if="getcartItems.name==='Tirzepatide'">Compounded w/ B6 (Pyridoxine)</div>
                                                            <div class="text-block-1068" v-else>Compounded w/ B12 (Cyanocobalamin)</div>
                                                         </div>
                                                        
                                                    </div>
                                                    <div class="text-block-1070">3-Month Supply - All Dosage Levels</div>
                                                </div>
                                            </div>
                                            <div class="text-block-1071 myclsforse">${{ getTotalPrice(3).toFixed(2) }}</div>
                                        </div>
                                        <cart-offer-row v-if="offerLineActive" :offer="cartOffer" :terms="paymentInfo.payment_terms" tile-class="_3months" />
                                        <div class="plandiscount-div">
                                            <div class="discounttype_div">
                                                <div class="text-block-1072">SAVINGS</div>
                                            </div>
                                            <div class="dicountamount_div">
                                                <img loading="lazy" src="@/assets/images/icon_tag.svg" alt="" class="image-586">
                                                <div class="discount-text">${{ calculateSavings(3).toFixed(2) }}</div>
                                            </div>
                                        </div>
                                        <div class="div-block-2102 checkout">
                                            <input class="text-field-62 coupon new w-input" v-model="couponInput" maxlength="256" name="field-3" data-name="Field 3" placeholder="Coupon Code" type="text" id="field-3" required="">
                                            <a href="#" @click.prevent="handleCouponSubmit" class="button-138 new w-button">Apply</a>
                                        </div>
                                    </div>
                                    <div class="planbox_div2">
                                        <div class="freebie_div">
                                            <div class="freebietypediv">
                                                <img loading="lazy" src="@/assets/images/icon_board-copy.svg" alt="" class="image-491">
                                                <div class="text-block-1073">Doctor Review &amp; Prescription</div>
                                            </div>
                                            <div class="discount-text free">INCLUDED</div>
                                        </div>
                                        <div class="freebie_div">
                                            <div class="freebietypediv">
                                                <img loading="lazy" src="@/assets/images/icon_support.svg" alt="" class="image-491">
                                                <div class="text-block-1073">Clinical Chat Support</div>
                                            </div>
                                            <div class="discount-text free">INCLUDED</div>
                                        </div>
                                        
                                        <div class="freebie_div">
                                            <div class="freebietypediv">
                                                <img loading="lazy" src="@/assets/images/66f29c17a6c44f05de988c80_icon_shipping.svg" alt="" class="image-491">
                                                <div class="text-block-1073">Overnight Cold Shipping</div>
                                            </div>
                                            <div class="discount-text free">INCLUDED</div>
                                        </div>
                                    </div>
                                    <p style="font-size:8px;line-height:1;padding-top:1px;">*The clinician consultation fee is included in the program cost and is paid directly to our independent doctor network partners. This fee is processed regardless of whether you qualify for treatment or receive a prescription. If your consultation results in a denial, you will not be responsible for this payment.</p>
                                    
                                    <div class="planbox_div3">
                                        <div class="text-block-1076">You're Saving ${{ calculateSavings(3).toFixed(2) }}</div>
                                        <div class="plansubtotal_div">
                                            <div class="text-block-1075">Due Today</div>
                                            <div class="subtotalamount_div">
                                                <div class="text-block-1077 ">${{ displayTotal.toFixed(2) }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="text-block-1450">
                                        <a href="#" @click.prevent="$router.go(-1)" class="link-75"><span class="text-span-333">&lt;- </span>Go back to Selection</a>
                                    </div>
                                    <a @click="fireCheckoutTracking" href="#payment-section" class="button-139 w-button">Next: Complete Payment &gt;</a>
                                </div>

                                <!-- 6-Month plan review section -->
                                <div class="checkout_planbox _6-months" v-if="paymentInfo.payment_terms === 6" style="display:block">
                                    <div class="planbox_div1">
                                        <div class="plan_div monthly">
                                            <div class="plandetails_div">
                                                <img sizes="(max-width: 1080px) 100vw, 1080px" :srcset="getImage" alt="" :src="getImage" loading="lazy" class="image-488 _6mo">
                                                <div class="planinfo-div">
                                                    <div class="infotop">
                                                        <div class="plannameplantype info-top">
                                                            <div class="text-block-1066 myclsforse">{{ getcartItems.name }}</div>
                                                            <div class="text-block-1067">6-MONTH PLAN</div>
                                                        </div>
                                                        <div class="plandosage_div">
                                                            <div class="text-block-1068" v-if="getcartItems.name==='Tirzepatide'">Compounded w/ B6 (Pyridoxine)</div>
                                                            <div class="text-block-1068" v-else>Compounded w/ B12 (Cyanocobalamin)</div>
                                                         </div>
                                                    </div>
                                                    <div class="text-block-1070">6-Month Supply - All Dosage Levels</div>
                                                </div>
                                            </div>
                                            <div class="text-block-1071 myclsforse">${{ getTotalPrice(6).toFixed(2) }}</div>
                                        </div>
                                        <cart-offer-row v-if="offerLineActive" :offer="cartOffer" :terms="paymentInfo.payment_terms" tile-class="_6mo" />
                                        <div class="text-block-1446">3 month supply now, 3 more in 90 days.</div>
                                        <div class="plandiscount-div">
                                            <div class="discounttype_div">
                                                <div class="text-block-1072">SAVINGS</div>
                                            </div>
                                            <div class="dicountamount_div">
                                                <img loading="lazy" src="@/assets/images/icon_tag.svg" alt="" class="image-586">
                                                <div class="discount-text">${{ calculateSavings(6).toFixed(2) }}</div>
                                            </div>
                                        </div>
                                        <div class="div-block-2102 checkout">
                                            <input class="text-field-62 coupon new w-input" v-model="couponInput" maxlength="256" name="field-3" data-name="Field 3" placeholder="Coupon Code" type="text" id="field-3" required="">
                                            <a href="#" @click.prevent="handleCouponSubmit" class="button-138 new w-button">Apply</a>
                                        </div>
                                    </div>
                                    <div class="planbox_div2">
                                        <div class="freebie_div">
                                            <div class="freebietypediv">
                                                <img loading="lazy" src="@/assets/images/icon_board-copy.svg" alt="" class="image-491">
                                                <div class="text-block-1073">Doctor Review &amp; Prescription</div>
                                            </div>
                                            <div class="discount-text free">INCLUDED</div>
                                        </div>
                                        <div class="freebie_div">
                                            <div class="freebietypediv">
                                                <img loading="lazy" src="@/assets/images/icon_support.svg" alt="" class="image-491">
                                                <div class="text-block-1073">Clinical Chat Support</div>
                                            </div>
                                            <div class="discount-text free">INCLUDED</div>
                                        </div>
                                       
                                        <div class="freebie_div">
                                            <div class="freebietypediv">
                                                <img loading="lazy" src="@/assets/images/66f29c17a6c44f05de988c80_icon_shipping.svg" alt="" class="image-491">
                                                <div class="text-block-1073">Overnight Cold Shipping</div>
                                            </div>
                                            <div class="discount-text free">INCLUDED</div>
                                        </div>
                                    </div>
                                    <p style="font-size:8px;line-height:1;padding-top:1px;">*The clinician consultation fee is included in the program cost and is paid directly to our independent doctor network partners. This fee is processed regardless of whether you qualify for treatment or receive a prescription. If your consultation results in a denial, you will not be responsible for this payment.</p>
                                    
                                    <div class="planbox_div3">
                                        <div class="text-block-1076">You're Saving ${{ calculateSavings(6).toFixed(2) }}</div>
                                        <div class="plansubtotal_div">
                                            <div class="text-block-1075">Due Today</div>
                                            <div class="subtotalamount_div">
                                                <div class="text-block-1077">${{ displayTotal.toFixed(2) }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="text-block-1450">
                                        <a href="#" @click.prevent="$router.go(-1)" class="link-75"><span class="text-span-333">&lt;- </span>Go back to Selection</a>
                                    </div>
                                    <a @click="fireCheckoutTracking" href="#payment-section" class="button-139 w-button">Next: Complete Payment &gt;</a>
                                </div>

                                <div class="checkout_planbox _6-months" v-if="paymentInfo.payment_terms === 12" style="display:block">
                                    <div class="planbox_div1">
                                        <div class="plan_div monthly">
                                            <div class="plandetails_div">
                                                <img sizes="(max-width: 1080px) 100vw, 1080px" :srcset="getImage" alt="" :src="getImage" loading="lazy" class="image-488 _6mo">
                                                <div class="planinfo-div">
                                                    <div class="infotop">
                                                        <div class="plannameplantype info-top">
                                                            <div class="text-block-1066 myclsforse">{{ getcartItems.name }}</div>
                                                            <div class="text-block-1067">12-MONTH PLAN</div>
                                                        </div>
                                                        <div class="plandosage_div">
                                                            <div class="text-block-1068" v-if="getcartItems.name==='Tirzepatide'">Compounded w/ B6 (Pyridoxine)</div>
                                                            <div class="text-block-1068" v-else>Compounded w/ B12 (Cyanocobalamin)</div>
                                                         </div>
                                                    </div>
                                                    <div class="text-block-1070">All Dosage Levels</div>
                                                </div>
                                            </div>
                                            <div class="text-block-1071 myclsforse">${{ getTotalPrice(12).toFixed(2) }}</div>
                                        </div>
                                        <cart-offer-row v-if="offerLineActive" :offer="cartOffer" :terms="paymentInfo.payment_terms" tile-class="_6mo" />
                                        <div class="text-block-1446">3 Vials Every 90 Days for a Year.</div>
                                        <div class="plandiscount-div">
                                            <div class="discounttype_div">
                                                <div class="text-block-1072">SAVINGS</div>
                                            </div>
                                            <div class="dicountamount_div">
                                                <img loading="lazy" src="@/assets/images/icon_tag.svg" alt="" class="image-586">
                                                <div class="discount-text">${{ calculateSavings(12).toFixed(2) }}</div>
                                            </div>
                                        </div>
                                        <div class="div-block-2102 checkout">
                                            <input class="text-field-62 coupon new w-input" v-model="couponInput" maxlength="256" name="field-3" data-name="Field 3" placeholder="Coupon Code" type="text" id="field-3" required="">
                                            <a href="#" @click.prevent="handleCouponSubmit" class="button-138 new w-button">Apply</a>
                                        </div>
                                    </div>
                                    <div class="planbox_div2">
                                        <div class="freebie_div">
                                            <div class="freebietypediv">
                                                <img loading="lazy" src="@/assets/images/icon_board-copy.svg" alt="" class="image-491">
                                                <div class="text-block-1073">Doctor Review &amp; Prescription</div>
                                            </div>
                                            <div class="discount-text free">INCLUDED</div>
                                        </div>
                                        <div class="freebie_div">
                                            <div class="freebietypediv">
                                                <img loading="lazy" src="@/assets/images/icon_support.svg" alt="" class="image-491">
                                                <div class="text-block-1073">Clinical Chat Support</div>
                                            </div>
                                            <div class="discount-text free">INCLUDED</div>
                                        </div>
                                       
                                        <div class="freebie_div">
                                            <div class="freebietypediv">
                                                <img loading="lazy" src="@/assets/images/66f29c17a6c44f05de988c80_icon_shipping.svg" alt="" class="image-491">
                                                <div class="text-block-1073">Overnight Cold Shipping</div>
                                            </div>
                                            <div class="discount-text free">INCLUDED</div>
                                        </div>
                                    </div>
                                    <p style="font-size:8px;line-height:1;padding-top:1px;">*The clinician consultation fee is included in the program cost and is paid directly to our independent doctor network partners. This fee is processed regardless of whether you qualify for treatment or receive a prescription. If your consultation results in a denial, you will not be responsible for this payment.</p>
                                    
                                    <div class="planbox_div3">
                                        <div class="text-block-1076">You're Saving ${{ calculateSavings(12).toFixed(2) }}</div>
                                        <div class="plansubtotal_div">
                                            <div class="text-block-1075">Due Today</div>
                                            <div class="subtotalamount_div">
                                                <div class="text-block-1077">${{ displayTotal.toFixed(2) }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="text-block-1450">
                                        <a href="#" @click.prevent="$router.go(-1)" class="link-75"><span class="text-span-333">&lt;- </span>Go back to Selection</a>
                                    </div>
                                    <a @click="fireCheckoutTracking" href="#payment-section" class="button-139 w-button">Next: Complete Payment &gt;</a>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <!-- Payment section -->
            <div id="payment-section" class="checkout_part-2">
                <div class="text-block-1064">3. Complete Payment</div>
                <div class="text-block-1447 checkout3">Lock in industry low pricing. <br/>Instant Refund if not approved.</div>

                <div style="border: 1px solid #000; border-radius: 9px;">
                    <div class="form-block-18 w-form">
                        <form id="email-form-3" name="email-form-3" data-name="Email Form 3" method="get">
                            <div class="checkout-3_-card-payment-div">

                                <!-- Express Checkout (Apple Pay / Google Pay / Klarna) -->
                                <div class="card-fields-div">
                                    <div class="express-checkout-section">
                                        <div class="express-checkout-box" :class="{ 'single-option': !canMakeExpressCheckout }" v-show="canMakeExpressCheckout || paymentInfo.payment_terms !== 1">
                                            <div v-show="canMakeExpressCheckout" id="express-checkout-element"></div>
                                            <button v-show="paymentInfo.payment_terms !== 1" type="button" class="klarna-btn" :disabled="submitted" @click="payWithKlarna">
                                                <span class="klarna-btn-text">Buy now, pay later with</span>
                                                <img class="klarna-logo" src="@/assets/images/Klarna.png" alt="Klarna" />
                                            </button>
                                        </div>
                                        <div class="divider" v-show="canMakeExpressCheckout || paymentInfo.payment_terms !== 1">
                                            <div class="divider-line"></div>
                                            <span>OR</span>
                                            <div class="divider-line"></div>
                                        </div>
                                    </div>
                                    <!-- Payment method section -->
                                <div class="div-block-2103 new">
                                    <div class="text-block-1451"><strong class="bold-text-4">Credit Card</strong></div>
                                    <img width="35" loading="lazy" alt="" src="https://uploads-ssl.webflow.com/657b2233d6a286f5c9f3844c/65ae6cf4027a5dcd36103790_visa.png" class="image-585">
                                    <img width="35" loading="lazy" alt="" src="https://uploads-ssl.webflow.com/657b2233d6a286f5c9f3844c/65ae6cf4027a5dcd36103780_mastercard.png" class="image-585">
                                    <img width="35" loading="lazy" alt="" src="https://uploads-ssl.webflow.com/657b2233d6a286f5c9f3844c/65ae6cf4027a5dcd36103794_AmEx.png" class="image-585">
                                    <img width="35" loading="lazy" alt="" src="https://uploads-ssl.webflow.com/657b2233d6a286f5c9f3844c/65ae6cf4027a5dcd3610377e_discover.png" class="image-585">
                                </div>
                                    <!-- Stripe Card Elements -->
                                    <div class="form-group">
                                        <label>Card number</label>
                                        <div id="card-number-element" class="ns-card-element"></div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group">
                                            <label>Expiration date</label>
                                            <div id="card-expiry-element" class="ns-card-element"></div>
                                        </div>
                                        <div class="form-group">
                                            <label>Security code</label>
                                            <div class="cvc-input-wrapper">
                                                <div id="card-cvc-element" class="ns-card-element"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <label for="email" class="pe-label-7x" style="margin-top: 20px; display: block;">Shipping Address</label>
                                <div :class="{ 'address-highlight': addressBlink }">
                                    <google-places-autocomplete :api-key="googleMapsApiKey" @address-updated="getAddressData" class="" />
                                </div>
                                <!-- <label class="w-checkbox checkbox-field-23">
                                    <input type="checkbox" name="checkbox-3" id="checkbox-3" @change="differentShipping = !differentShipping" data-name="Checkbox 3" class="w-checkbox-input">
                                    <span class="checkbox-label-24 w-form-label" for="checkbox-3">Different Billing Address?</span>
                                </label> -->

                                <!-- Billing address section (conditional) -->
                                <!-- <div v-if="differentShipping">
                                    <label for="email" class="field-label-5">Billing Address</label>
                                    <div class="">
                                        <div class="">
                                            <google-places-autocomplete :api-key="googleMapsApiKey" @address-updated="getAddressDataBilling" class="" />
                                        </div>
                                    </div>
                                </div> -->
                                <!-- Checkout API Error Banner -->
                                <div v-if="checkoutErrorMessage" class="checkout-error-banner">
                                    <div class="checkout-error-banner-content">
                                        <span class="checkout-error-icon">&#9888;</span>
                                        <div class="checkout-error-text">
                                            <div class="checkout-error-heading">Payment failed</div>
                                            <div class="checkout-error-message">{{ checkoutErrorMessage }}</div>
                                            <div class="checkout-error-helper">Please check your card details and try again, or use a different payment method.</div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Validation/tokenization error display -->
                                <div v-if="paymentError" class="w-form-fail" style="display:block;">
                                    <div >{{ errorMessage }}</div>
                                </div>

                                <!-- Submit button -->
                                <input type="submit" @click.prevent="getStripeToken" data-wait="Please wait..." class="submit-button-20 new w-button" value="BUY NOW">

                                <!-- Subscription agreement -->
                                <div class="subscription-agreement">
                                    <p class="disclaimer-paragraph">By enrolling, I acknowledge that I am signing up for a recurring subscription and authorize RXposed to charge my selected payment method at the applicable renewal rate until I cancel.</p>
                                    <p class="disclaimer-paragraph">I may cancel my subscription at any time through my patient portal. To avoid future charges, I must cancel before my next scheduled renewal date.</p>
                                    <p class="disclaimer-paragraph">More than 80% of our members continue GLP-1 therapy for longer than six months. RXposed is committed to supporting members throughout their treatment journey while offering some of the most competitive pricing available online.</p>
                                </div>

                                <!-- Disclaimer -->
                                <div class="div-block-2099">
                                    <p class="disclaimer-paragraph">
                                        By clicking "Buy Now and Save" or checking out with Apple or Google Pay you agree to enroll in a {{ paymentInfo.payment_terms }}-month program billed {{ getBillingFrequency() }}, with automatic renewal and charges until canceled. You authorize recurring payments and confirm that you have read and agree to the <a href="https://rxpros.com/returns" target="_blank" class="disc-link">Refund Policy</a>, <a href="https://rxpros.com/terms" target="_blank" class="disc-link">Terms and Conditions</a>, <a href="https://rxpros.com/terms" target="_blank" class="disc-link">Terms of Use</a>, <a href="https://rxpros.com/privacy" target="_blank" class="disc-link">Privacy Policy</a>, <a href="https://rxpros.com/hipaa" target="_blank"  class="disc-link">HIPAA Notice</a>, and <a href="https://rxpros.com/telehealth" target="_blank" class="disc-link">Telehealth Consent</a>, and are at least 18 years of age.
                                    </p>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
</template>

    
    
<script>
import { loadStripe } from "@stripe/stripe-js"
let stripe = null;
let paymentElements = null;
let elements = null;
// In-flight live-plan load, shared so the pay-time check waits on the background
// attempt instead of starting a competing one. Cleared when a chain gives up.
let plansRequest = null;

// Live-plan fetch tuning. Long enough that a slow mobile connection still
// succeeds, bounded so nothing ever sits on a stalled request.
const PLANS_REQUEST_TIMEOUT_MS = 8000;   // per attempt
const PLANS_MAX_ATTEMPTS = 4;            // first try + 3 retries
const PLANS_RETRY_BACKOFF_MS = [1000, 2500, 5000];
const PLANS_PAY_WAIT_MS = 6000;          // longest a customer waits at the pay button
const PLANS_INIT_WAIT_MS = 2500;         // longest the cart loader is held for first paint

import detectMobile from '@/utils/MobileDetection.js';
import GooglePlacesAutocomplete from '../common/GooglePlacesAutocomplete.vue';
import blurryLoader from '../common/blurryLoader.vue';
import FastTrackUpsellModal from './FastTrackUpsellModal.vue';
import CartOfferRow from './CartOfferRow.vue';
import { loadFastTrackAddon } from '@/utils/fastTrackUpsell';
import { isOfferActive, withOfferLine, offerSlug, klarnaSnapshotItems } from '@/utils/cartOffer';
import { loadFreeNadOffer, requestedFreeNadOffer } from '@/utils/freeNadLife';
import { fireOrderPurchase } from '@/utils/orderPurchaseTracking';
import { paymentMethodFromExpressType } from '@/utils/paymentMethod';
import { needsBankCheck, runBankChecks, shopperMessage } from '@/utils/bankCheck';
import { BLOCKED_STATE_MESSAGE, isBlockedState } from '@/utils/blockedStates';
import {
    mapActions,
    mapGetters
} from 'vuex';

// Five-digit ZIP or ZIP+4, the pattern GooglePlacesAutocomplete parses a typed address with.
const US_ZIP = /^\d{5}(-\d{4})?$/;

export default {
    name: 'CheckoutComponent',
    components: {
        GooglePlacesAutocomplete,
        blurryLoader,
        FastTrackUpsellModal,
        CartOfferRow,
    },
    props: ['baseUrl', 'stripeKey', 'googleMapsApiKey'],
    data() {
        return {
            updateKey: 1,
            appName: process.env.VUE_APP_COMPANY || 'RxPros',
            appMainWeb: process.env.VUE_APP_HOMEPAGE || 'https://rxpros.com',
            assetPath: '/images', // Path to your assets/images
            payment_open: 0,
            paymentError: false,
            errorMessage: '',
            initilizingCart: true,
            cartError: false,
            isApplePaySupported: false,
            isGooglePaySupported: false,
            differentShipping: false,
            couponValid: true,
            couponError: false,
            couponApplied: false,
            addressError: false,
            submitted: false,
            // Priority Physician Review. Resolved from the catalog while the customer
            // fills the form, then offered as a yes/no modal AFTER the order is
            // captured — it is a separate charge and touches no checkout payload.
            // null (product missing or inactive) means no offer is ever made.
            fastTrackAddon: null,
            fastTrackOfferOpen: false,
            // Session id resolved for the order's charge, reused by the add-on charge so
            // both land on the same tracking session.
            trackingSessionId: '',
            // Where to go once the offer is answered: the redirect the order would
            // have made immediately if there were no offer to show.
            fastTrackPendingRoute: null,
            trustUrl: '',
            couponInput: '',
            message: '',
            offer: '',
            // The free NAD+ from an offer link (utils/freeNadLife.js), or null. Shape and
            // rules in utils/cartOffer.js. Read-only: the order on the link keeps it.
            cartOffer: null,
            freeNadLoading: false,
            termsAccepted: true,
            // Stripe Card Elements (individual)
            cardNumberElement: null,
            cardExpiryElement: null,
            cardCvcElement: null,
            hasCardInput: false,
            expressCheckoutElement: null,
            canMakeExpressCheckout: false,
            defaultProduct: null,
            ip_address:'',
            checkoutErrorMessage: '',
            toastMessage: '',
            addressBlink: false,
            phone: {
                area: '',
                prefix: '',
                line: ''
            },
            customerInfo: {
                id: '',
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: '',
                zip: ''
            },
            // The shipping address last sent to save-address before payment.
            savedAddressKey: null,
            billingAddress: {
                id: '',
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: '',
                zip: ''
            },
            paymentInfo: {
                payment_terms: 6, // Default to monthly plan
                user_id: '',
                cardToken: '',
                amount: 249.97, // Default amount for first month
                discount: 0,
                medication: '',
                couponCode: '',
                drug_mode: '',
                couponId: null,
                paymentMethod: null,
                cartItems: [],
                cardDetails: [],
                planId: '',
                // Card info from Stripe
                cardBin: '',
                cardLast4: '',
                cardBrand: '',
            },
            // Centralized configuration for pricing - easier to maintain
            pricingConfig: {
                semaglutide: {
                    monthly: {
                        first: 195.99,
                        regular: 195.99
                    },
                    terms: {
                        3: 452.97,
                        6: 755.94,
                        12: 1199.88
                    }
                },
                tirzepatide: {
                    monthly: {
                        first: 275.99,
                        regular: 275.99
                    },
                    terms: {
                        3: 647.97,
                        6: 1109.82,
                        12: 1739.64
                    }
                }
            },
            // Live promo plans from /api/get-all-plans keyed by payment_terms: { id, price }.
            // Empty until loadPlans resolves; on fetch failure it stays empty so pricing
            // falls back to pricingConfig and planId falls back to the store offer.
            apiPlans: {},
            // Centralized labels for payment terms - easier to maintain
            paymentTermLabels: {
                1: {
                    planName: "Monthly Plan",
                    duration: "monthly",
                    billingFrequency: "monthly",
                    billingLabel: "Billed Monthly",
                    supplyDuration: "Monthly"
                },
                3: {
                    planName: "Quarterly Plan",
                    duration: "3-month",
                    billingFrequency: "quarterly",
                    billingLabel: "Billed Quarterly",
                    supplyDuration: "3 Month"
                },
                6: {
                    planName: "Half Yearly Plan",
                    duration: "6-month",
                    billingFrequency: "every 6 months",
                    billingLabel: "Billed Every 6 Months",
                    supplyDuration: "6 Month"
                },
                12: {
                    planName: "Yearly Plan",
                    duration: "12-month",
                    billingFrequency: "annually",
                    billingLabel: "Billed Annually",
                    supplyDuration: "12 Month"
                }
            },
            checkoutTracked: false,
        };
    },

    async mounted() {
        await this.checkAuthAndInitialize();
        await this.getIpAddress();

        // Resolved up front, never at success time: a customer who has just paid must
        // not wait on a catalog request before being sent to their confirmation.
        this.fastTrackAddon = await loadFastTrackAddon(this.baseUrl);

        window.addEventListener('pageshow', this.handlePageShow);
    },

    beforeDestroy() {
        window.removeEventListener('pageshow', this.handlePageShow);
    },

    created() {
        // The free NAD+ an offer link asks for, resolved while the customer fills the
        // form. Not reactive: requireFreeNad only awaits it.
        const requested = requestedFreeNadOffer(this.$route.query);
        if (requested) {
            this.freeNadLoading = true;
            this.freeNadLoad = loadFreeNadOffer(this.baseUrl, requested).then((offer) => {
                this.cartOffer = offer;
                this.freeNadLoading = false;
            });
        }

        // Set default product if not available
        this.defaultProduct = {
            name: 'Tirzepatide',
            quantity: 1,
            image: 'https://rxpros.s3.us-east-2.amazonaws.com/public/assets/product_image/webp/tirzepatide/1.webp',
            category: "Weight",
            id: "675ac4cb6bf102c19ec3afe9",
            main_type: 1,
            price: 275.99,
            retail_price: 275.99,
            stripe_id: 'tirz_plan_1',
            kku: '23_1',
            subheader: "Compound Medication"
        };

    },

    watch: {
        isMobile: {
            immediate: true,
            handler(newVal) {
                console.log('Mobile view:', newVal);
            }
        },
        'paymentInfo.payment_terms'() {
            this.couponInput = "";
            this.paymentInfo.couponId = null;
            this.couponApplied = false;
            this.paymentInfo.discount = 0;
            this.updatePaymentRequestAmount();
            // Only after the first add_to_cart, so a plan resolved while the page is
            // still loading does not report ahead of it.
            if (this.checkoutTracked) {
                this.trackPlanChoice();
            }
        },
        'paymentInfo.discount'() {
            this.updatePaymentRequestAmount();
        },
        paymentError(val) {
            if (val && this.errorMessage) {
                this.showToast(this.errorMessage);
            }
        },
        checkoutErrorMessage(val) {
            if (val) {
                this.showToast(val);
            }
        }
    },

    methods: {
        // One shape for every money event on this checkout, so add_to_cart and
        // choose_plan can never report different prices for the same cart.
        cartTrackingParams(funnelStep) {
            const productName = this.getcartItems?.name || 'Tirzepatide';
            const productId = this.getcartItems?.id || this.getcartItems?.sku || '';
            const eventValue = this.getCurrentPrice();
            let eventId = null;

            try {
                const stored = JSON.parse(localStorage.getItem('tracking_checkout') || '{}');
                if (stored.event_id) eventId = stored.event_id;
            } catch (error) {
                console.error('tracking_checkout read failed', error);
            }

            return {
                funnel_step: funnelStep,
                form: 'home',
                event_id: eventId,
                // event_value is the param the pixel spec reads for money. value and
                // items stay alongside it for the reports already built on them.
                event_value: eventValue,
                value: eventValue,
                currency: 'USD',
                product_id: productId,
                product_name: productName,
                // selectedPlanId first: paymentInfo.planId is not filled until
                // processPayment runs, so reading it here reported every cart with a
                // blank plan even though the live plan was already resolved.
                plan_id: this.selectedPlanId || this.paymentInfo.planId || '',
                quantity: 1,
                label: `${productName.toLowerCase()}_${this.paymentInfo.payment_terms}mo`,
                items: [{
                    item_id: productId,
                    item_name: productName,
                    price: eventValue,
                    quantity: 1
                }]
            };
        },

        // The plan boxes have no Next of their own — the next press is Buy Now — so
        // the tap is the commit. choose_plan records the selection and add_to_cart
        // re-fires at the real price, so a patient who switches plans and then
        // abandons is not reported at the price they moved away from.
        trackPlanChoice() {
            try {
                if (!window.tracking) return;

                const params = this.cartTrackingParams(11);
                window.tracking.event('choose_plan', params);
                window.tracking.event('add_to_cart', params);

                const existing = JSON.parse(localStorage.getItem('tracking_checkout') || '{}');
                localStorage.setItem('tracking_checkout', JSON.stringify({
                    ...existing,
                    event_value: params.event_value,
                    currency: 'USD'
                }));
            } catch (error) {
                console.error('choose_plan tracking failed', error);
            }
        },

        fireCheckoutTracking() {
            if (this.checkoutTracked) return;
            try {
                if (window.tracking) {
                    const params = this.cartTrackingParams(10);

                    window.tracking.event('add_to_cart', params);
                    window.tracking.event('questionnaire_end', { funnel_step: 10, form: 'home' });
                    this.checkoutTracked = true;
                    // Update tracking_checkout with full payload — purchase event on /payment/thanks reads this
                    try {
                        const existing = JSON.parse(localStorage.getItem('tracking_checkout') || '{}');
                        localStorage.setItem('tracking_checkout', JSON.stringify({
                            ...existing,
                            product_name: params.product_name,
                            product_id: params.product_id,
                            event_value: params.event_value,
                            currency: 'USD',
                        }));
                    } catch (e) { console.log('tracking_checkout update failed', e); }

                    // The checkout opens on a plan already selected, so report that
                    // default too rather than only the patients who change it.
                    this.trackPlanChoice();
                }
            } catch (error) {
                console.log('add_to_cart tracking error', error);
            }
        },
        ...mapActions([
            'setCartVisibility',
            'clearCart',
            'addToCart',
            'doLogin',
            'setPrescriptionPreauths',
            'addSemaOffer',
            'addTirOffer'
        ]),

        showToast(msg) {
            this.toastMessage = '';
            this.$nextTick(() => {
                this.toastMessage = msg;
                setTimeout(() => { this.toastMessage = ''; }, 5000);
            });
        },

        blinkAddress() {
            this.addressBlink = false;
            this.$nextTick(() => {
                this.addressBlink = true;
                setTimeout(() => { this.addressBlink = false; }, 1500);
            });
        },

        handlePageShow(event) {
            if (event.persisted) {
                this.submitted = false;
            }
        },

        async initStripe() {
            try {
                stripe = await loadStripe(process.env.VUE_APP_STRIPE_KEY);
                // Payment Elements instance — used only for Express Checkout (Apple/Google Pay)
                paymentElements = stripe.elements({
                    mode: 'payment',
                    amount: this.amountInCents,
                    currency: 'usd',
                    paymentMethodTypes: ['card'],
                    paymentMethodCreation: 'manual',
                });
                // Classic Elements instance — used for individual card fields (no icons)
                elements = stripe.elements();
            } catch (error) {
                console.error('Failed to initialize Stripe:', error);
            }
        },

        updatePaymentRequestAmount() {
            if (!paymentElements) return;
            // No discount subtraction here: amountInCents already nets out the coupon
            // (getCurrentPrice subtracts it), so taking it off again showed the wallet
            // customer a total below what they were charged.
            paymentElements.update({ amount: this.amountInCents });
        },

        createExpressCheckout() {
            if (!paymentElements) return;

            if (this.expressCheckoutElement) {
                this.expressCheckoutElement.mount('#express-checkout-element');
                return;
            }

            // NOTE: First try GPay/Apple Pay only. If neither is available,
            // re-create the element with Link enabled as a fallback.
            this.mountExpressCheckout({ allowLink: false });
        },

        mountExpressCheckout({ allowLink }) {
            const paymentMethods = {
                applePay: 'auto',
                googlePay: 'auto',
                paypal: 'never',
                amazonPay: 'never',
            };
            paymentMethods.link = allowLink ? 'auto' : 'never';

            this.expressCheckoutElement = paymentElements.create('expressCheckout', {
                buttonHeight: 48,
                paymentMethods,
                paymentMethodOrder: ['googlePay', 'applePay', 'link'],
                layout: {
                    overflow: 'never',
                },
            });
            this.expressCheckoutElement.on('ready', ({ availablePaymentMethods }) => {
                // If GPay/Apple Pay aren't available and we haven't tried Link yet,
                // recreate with Link enabled as fallback.
                if (!allowLink && !availablePaymentMethods) {
                    this.expressCheckoutElement.unmount();
                    this.expressCheckoutElement.destroy();
                    this.expressCheckoutElement = null;
                    this.mountExpressCheckout({ allowLink: true });
                    return;
                }
                this.canMakeExpressCheckout = !!availablePaymentMethods;
            });
            this.expressCheckoutElement.on('confirm', this.handleExpressCheckoutConfirm);
            this.expressCheckoutElement.mount('#express-checkout-element');
        },

        async handleExpressCheckoutConfirm(event) {
            if (this.submitted) { event.paymentFailed({ reason: 'fail' }); return; } // a charge is already in flight
            if (this.stopForBlockedState(event.billingDetails?.address?.state)) { event.paymentFailed({ reason: 'fail' }); return; }
            // Check the plan before tokenizing — the Apple/Google Pay sheet has to be
            // dismissed with paymentFailed, so this can't rely on processPayment bailing.
            if (!await this.requirePlanId()) { event.paymentFailed({ reason: 'fail' }); return; }
            try {
                this.submitted = true;
                this.paymentError = false;

                const { error: submitError } = await paymentElements.submit();
                if (submitError) {
                    event.paymentFailed({ reason: 'invalid_payment_data' });
                    this.paymentError = true;
                    this.errorMessage = submitError.message || 'Payment failed.';
                    this.submitted = false;
                    return;
                }

                const { paymentMethod, error } = await stripe.createPaymentMethod({
                    elements: paymentElements,
                });

                if (error) {
                    event.paymentFailed({ reason: 'invalid_payment_data' });
                    this.paymentError = true;
                    this.errorMessage = error.message || 'Payment failed.';
                    this.submitted = false;
                    return;
                }

                if (event.billingDetails?.address) {
                    const addr = event.billingDetails.address;
                    this.billingAddress = {
                        addressLine1: addr.line1 || '',
                        addressLine2: addr.line2 || '',
                        city: addr.city || '',
                        state: addr.state || '',
                        zip: addr.postal_code || ''
                    };
                }

                this.paymentInfo.cardToken = paymentMethod.id;
                // Link rides in this same element as the fallback button, so the old
                // "apple_pay or else google_pay" test filed every Link order as Google Pay.
                this.paymentInfo.paymentMethod = paymentMethodFromExpressType(event.expressPaymentType);
                try {
                    this.paymentInfo.cardDetails = {
                        number: `XXXXXXXXXXXX${paymentMethod.card.last4}`,
                        expiration_month: paymentMethod.card.exp_month,
                        expiration_year: paymentMethod.card.exp_year,
                        cardBin: '',
                        cardBrand: paymentMethod.card.brand,
                        cardLast4: paymentMethod.card.last4,
                    };
                    this.paymentInfo.cardLast4 = paymentMethod.card.last4;
                    this.paymentInfo.cardBrand = paymentMethod.card.brand;
                } catch (e) {
                    console.warn('Could not extract card details from paymentMethod', e);
                }
                await this.processPayment();
            } catch (err) {
                console.error('Express checkout payment failed:', err);
                event.paymentFailed({ reason: 'fail' });
                this.paymentError = true;
                this.errorMessage = 'Payment failed. Please try again or use a different payment method.';
                this.submitted = false;
            }
        },

        // Starts (or joins) the live-plan load. Never awaited during cart init — the
        // page renders straight away and this settles in the background while the
        // customer fills the form, so a slow connection costs them nothing.
        loadPlans() {
            if (!plansRequest) {
                plansRequest = this.fetchPlansWithRetry();
            }
            return plansRequest;
        },

        // Retries a failed fetch a few times with growing gaps. A single dropped
        // request on flaky mobile was previously enough to leave the page with no
        // plan for the whole session.
        async fetchPlansWithRetry() {
            if (!this.getcartItems?.id) {
                plansRequest = null;
                return false;
            }
            for (let attempt = 0; attempt < PLANS_MAX_ATTEMPTS; attempt++) {
                if (attempt > 0) {
                    const wait = PLANS_RETRY_BACKOFF_MS[attempt - 1];
                    await new Promise((resolve) => setTimeout(resolve, wait));
                }
                if (await this.fetchPlansOnce()) return true;
            }
            // Let a later attempt (e.g. from the pay button) start a fresh chain.
            plansRequest = null;
            return false;
        },

        async fetchPlansOnce() {
            try {
                const productId = this.getcartItems?.id;
                if (!productId) return false;
                const response = await this.$axios.get(`${this.baseUrl}/api/get-all-plans`, {
                    params: { isPromo: true, productId },
                    timeout: PLANS_REQUEST_TIMEOUT_MS
                });
                if (response.data.status === 'success' && Array.isArray(response.data.plans)) {
                    const plans = {};
                    response.data.plans.forEach((plan) => {
                        if (plan && plan.terms != null && plan.price != null) {
                            plans[Number(plan.terms)] = { id: plan.id, price: Number(plan.price) };
                        }
                    });
                    if (Object.keys(plans).length > 0) {
                        this.apiPlans = plans;
                        // Plans can land after Stripe was set up with the fallback price,
                        // so resync the Apple/Google Pay sheet to the live total.
                        this.updatePaymentRequestAmount();
                        return true;
                    }
                }
            } catch (error) {
                console.error('Error loading plans:', error);
            }
            return false;
        },

        // Hold the cart loader briefly so the live prices are already on screen at first
        // paint — otherwise the fallback price shows for about a second and then visibly
        // changes to the promo price. Capped, so a slow API delays the page by at most
        // this long; the retries keep running and prices update when they land.
        async waitForInitialPlans() {
            await Promise.race([
                this.loadPlans(),
                new Promise((resolve) => setTimeout(resolve, PLANS_INIT_WAIT_MS))
            ]);
        },

        // Gate on every payment path. An empty planId makes the backend fall back to a
        // higher price, so refusing the charge is cheaper than the overcharge and the
        // chargeback that follows. Waits only on the in-flight load, capped, so the
        // customer never sits at a dead button.
        async requirePlanId() {
            if (!await this.requireFreeNad()) return false;
            if (this.selectedPlanId) return true;

            await Promise.race([
                this.loadPlans(),
                new Promise((resolve) => setTimeout(resolve, PLANS_PAY_WAIT_MS))
            ]);
            if (this.selectedPlanId) return true;

            this.paymentError = true;
            this.errorMessage = 'We could not confirm current pricing. Please try again in a moment.';
            this.submitted = false;
            return false;
        },

        // Pay is held while an offer link's free NAD+ resolves: paying then would leave
        // it off the order. The load never fails (a failure is a normal order), so this
        // waits on it, capped like the plan load. Copy from the gorxpros za checkout.
        async requireFreeNad() {
            if (!this.freeNadLoading) return true;
            await Promise.race([
                this.freeNadLoad,
                new Promise((resolve) => setTimeout(resolve, PLANS_PAY_WAIT_MS))
            ]);
            if (!this.freeNadLoading) return true;

            this.paymentError = true;
            this.errorMessage = 'Payment is still loading. Give it a second and try again.';
            this.submitted = false;
            return false;
        },

        // PRICING METHODS - Centralized pricing logic for easier maintenance
        getProductPricing() {
            const productName = this.getcartItems?.name || 'Tirzepatide';
            const base = productName === 'Semaglutide' ?
                this.pricingConfig.semaglutide :
                this.pricingConfig.tirzepatide;
            // Merge live promo prices over the fallback pricing so missing terms keep the fallback
            const pricing = { monthly: { ...base.monthly }, terms: { ...base.terms } };
            if (this.apiPlans[1]) {
                pricing.monthly = { first: this.apiPlans[1].price, regular: this.apiPlans[1].price };
            }
            [3, 6, 12].forEach((term) => {
                if (this.apiPlans[term]) {
                    pricing.terms[term] = this.apiPlans[term].price;
                }
            });
            return pricing;
        },

        getFirstMonthPrice() {
            return this.getProductPricing().monthly.first - this.paymentInfo.discount;
        },

        getRegularMonthlyPrice() {
            return this.getProductPricing().monthly.regular;
        },

        getMonthlyDiscount() {
            return this.getRegularMonthlyPrice() - this.getFirstMonthPrice();
        },

        getTotalPrice(term) {
            return this.getProductPricing().terms[term] - this.paymentInfo.discount;
        },

        getMonthlyPrice(term) {
            return this.getTotalPrice(term) / term;
        },

        getCurrentPrice() {
            // Floored at 0 so a coupon worth more than the plan can't send a negative
            // amount to Stripe, the same guard newself's getTotalOrderAmount applies.
            if (this.paymentInfo.payment_terms === 1) {
                return Math.max(0, this.getFirstMonthPrice());
            } else {
                return Math.max(0, this.getTotalPrice(this.paymentInfo.payment_terms));
            }
        },

        // ORDER PAYLOAD HELPERS - what the backend is told this order is worth.
        // Every figure is the selected plan's total, so a 6-month order reports the
        // 6-month price rather than the cart item's single-month price.
        orderTotal() {
            return parseFloat(this.getCurrentPrice().toFixed(2));
        },

        orderTotalNoDiscount() {
            return parseFloat((this.getCurrentPrice() + (this.paymentInfo.discount || 0)).toFixed(2));
        },

        // The cart item repriced to the selected plan, so cartItems[].price matches
        // the amount charged instead of the per-month price the cart was saved with.
        // An offer link's free NAD+ line follows it, at $0.
        orderCartItems() {
            const item = this.cartItems.length > 0 ? this.cartItems[0] : this.defaultProduct;
            return withOfferLine([{
                ...item,
                quantity: item.quantity || 1,
                price: this.orderTotal(),
                retail_price: this.orderTotalNoDiscount(),
            }], this.cartOffer, this.paymentInfo.payment_terms);
        },

        // Offers Priority Physician Review if the catalog has it, otherwise goes
        // straight to the confirmation. Called only after the order is captured, so
        // the redirect is stashed rather than dropped: whichever way the customer
        // answers, pushToRoute still runs with the order's own amount and id.
        offerFastTrackOrRoute(amountCharged, transactionIdentifier) {
            if (!this.fastTrackAddon) {
                this.pushToRoute(amountCharged, transactionIdentifier);
                return;
            }
            this.fastTrackPendingRoute = { amountCharged, transactionIdentifier };
            this.fastTrackOfferOpen = true;
        },

        closeFastTrackOffer() {
            this.fastTrackOfferOpen = false;
            const pending = this.fastTrackPendingRoute;
            this.fastTrackPendingRoute = null;
            if (pending) {
                this.pushToRoute(pending.amountCharged, pending.transactionIdentifier);
            }
        },

        // Calculate the total savings compared to monthly pricing
        calculateSavings(term) {
            const monthlyPlanTotal = this.getFirstMonthPrice() + (this.getRegularMonthlyPrice() * (term - 1));
            const prepaidTotal = this.getTotalPrice(term);
            return monthlyPlanTotal - (prepaidTotal - this.paymentInfo.discount);
        },

        // Get the billing frequency text based on selected term
        getBillingFrequency() {
            return this.paymentTermLabels[this.paymentInfo.payment_terms].billingFrequency;
        },

        async changeItem(currentName) {
            try {
                // Reset states
                this.couponInput = "";
                this.paymentInfo.couponId = null;
                this.couponApplied = false;
                this.paymentInfo.discount = 0;
                this.paymentError = false;
                this.submitted = false;

                // Create new item with appropriate pricing based on medication type
                const newItem = {
                    name: currentName === 'Semaglutide' ? 'Tirzepatide' : 'Semaglutide',
                    quantity: 1,
                    image: currentName === 'Semaglutide' ?
                        'https://prioritymeds.s3.us-east-1.amazonaws.com/public/assets/product_image/webp/tirzepatide/1.webp' : 'https://prioritymeds.s3.us-east-1.amazonaws.com/public/assets/product_image/webp/semaglutide/1.webp',
                    category: "Weight",
                    id: currentName === 'Semaglutide' ? "675ac4cb6bf102c19ec3afe9" : "675ac4cb6bf102c19ec3afec",
                    main_type: 1,
                    price: currentName === 'Semaglutide' ?
                        this.pricingConfig.tirzepatide.monthly.first : this.pricingConfig.semaglutide.monthly.first,
                    retail_price: currentName === 'Semaglutide' ?
                        this.pricingConfig.tirzepatide.monthly.regular : this.pricingConfig.semaglutide.monthly.regular,
                    stripe_id: currentName === 'Semaglutide' ? 'tirz_plan_1' : 'sema_plan_278928',
                    kku: currentName === 'Semaglutide' ? '23_1' : "24",
                    subheader: "Compound Medication"
                };

                // Update cart
                await this.clearCart();
                await this.addToCart(newItem);
                this.setCartVisibility(false);
                window.location.reload();

                
                if (this.cardElement) {
                    this.cardElement.clear();
                }

                

            } catch (error) {
                console.error('Error switching medication:', error);
                this.paymentError = true;
                this.errorMessage = "Error switching medication. Please try again.";
            }
        },

        showChatWindow() {
            this.$emit("showChatWindow");
        },

        getPhoneNumber() {
            return `${this.phone.area}-${this.phone.prefix}-${this.phone.line}`;
        },

        async handleCouponSubmit() {
            this.errorMessage = null;
            if (!this.couponInput) {
                this.errorMessage = 'Please enter a coupon code';
                return;
            }
            this.paymentInfo.couponCode = this.couponInput;
            await this.validateCoupon();
        },

        async validateCoupon() {
            if (this.couponApplied) return;
            this.couponError = false;
            try {
                const response = await this.$axios.post(`${this.baseUrl}/api/validate-coupon`, {
                    coupon: this.paymentInfo.couponCode,
                    payment_terms: this.paymentInfo.payment_terms
                });

                if (response.data.status === 'success') {
                    this.couponValid = true;
                    this.couponApplied = true;
                    this.paymentInfo.couponId = response.data.coupon_id;
                    this.paymentInfo.discount = response.data.c_val;
                } else {
                    this.couponValid = false;
                    this.couponError = true;
                }
            } catch (error) {
                this.couponValid = false;
                this.couponError = true;
            }
        },

        async checkAuthAndInitialize() {
            if (!this.isLoggedin) {
                
                // If cart_id is available in route params, try to fetch cart data
                if (this.$route.params.cart_id) {
                    this.$axios.get(`${this.baseUrl}/api/get-cart/${this.$route.params.cart_id}`, {
                            headers: {
                                'Content-Type': 'application/json',
                            }
                        }).then(response => {
                            if (response.data.status === 'success') {
                                let cartItem = response.data.cartItem;
                                try {
                                    let keyToDelete = "sema_offer";
                                    if (Object.prototype.hasOwnProperty.call(cartItem, keyToDelete)) {
                                        this.addSemaOffer(cartItem[keyToDelete]);
                                        delete cartItem[keyToDelete];
                                    }
                                    keyToDelete = "tir_offer";
                                    if (Object.prototype.hasOwnProperty.call(cartItem, keyToDelete)) {
                                        this.addTirOffer(cartItem[keyToDelete]);
                                        delete cartItem[keyToDelete];
                                    }
                                } catch (error) {
                                    console.log(error.message)
                                }

                                this.doLogin(response.data.userData);
                                if (!Object.prototype.hasOwnProperty.call(cartItem, 'is_addon')) {
                                    cartItem.is_addon = false;
                                }
                                
                                this.addToCart(cartItem);
                                this.setCartVisibility(false);
                                window.location.reload();

                            } else {
                                this.initilizingCart = false;
                                this.message = response.data.message;
                                this.cartError = true;
                                console.error("Unexpected response:", response.data);
                            }
                        })
                        .catch(error => {
                            console.error("Error saving cart:", error);
                            this.initilizingCart = false;
                            this.message = `${error.message}. Please check the checkout link is correct.`
                            this.cartError = true;
                        });
                } else {
                    // No cart_id, use default product
                    await this.waitForInitialPlans();
                    this.initilizingCart = false;
                    await this.initStripe();
                    this.createCardElement();
                    this.createExpressCheckout();
                }
            } else {
                await this.waitForInitialPlans();
                this.initilizingCart = false;
                await this.initStripe();
                this.createCardElement();
                this.createExpressCheckout();
            }
        },

        createCardElement() {
            if (!elements) return;

            const style = {
                base: {
                    fontSize: '15px',
                    fontWeight: 'normal',
                    color: '#000',
                    '::placeholder': {
                        color: '#9ca3af',
                        fontWeight: 'normal'
                    }
                }
            };

            // showIcon: false removes the card brand logos from inside the input
            if (!this.cardNumberElement) {
                this.cardNumberElement = elements.create('cardNumber', {
                    style,
                    placeholder: '1234 1234 1234 1234',
                    showIcon: false,
                });
                this.cardNumberElement.mount('#card-number-element');
                this.cardNumberElement.on('change', (event) => {
                    this.hasCardInput = !event.empty;
                    if (event.brand) this.paymentInfo.cardBrand = event.brand;
                });
            }

            if (!this.cardExpiryElement) {
                this.cardExpiryElement = elements.create('cardExpiry', { style, placeholder: 'MM / YY' });
                this.cardExpiryElement.mount('#card-expiry-element');
            }

            if (!this.cardCvcElement) {
                this.cardCvcElement = elements.create('cardCvc', { style, placeholder: 'CVC' });
                this.cardCvcElement.mount('#card-cvc-element');
            }
        },

        isPOBox(address) {
                const normalized = address.toLowerCase().replace(/\./g, '').replace(/\s+/g, ' ');
                const poBoxRegex = /\b(po box|post office box|p o box)\b(?:\s*\d{0,6})?/i;
                return poBoxRegex.test(normalized);
            },
        getAddressData(address) {
            if(this.isPOBox(address.street)){
                this.addressError= true;
                this.customerInfo.addressLine2 = address.address_line2;
                this.customerInfo.city = address.city;
                this.customerInfo.state = address.state;
                this.customerInfo.zip = address.zip;
            }else{
                this.addressError= false;
                this.customerInfo.addressLine1 = address.street;
                this.customerInfo.addressLine2 = address.address_line2;
                this.customerInfo.city = address.city;
                this.customerInfo.state = address.state;
                this.customerInfo.zip = address.zip;
                // Kept on the page so the payment gate sees it, never saved to the profile.
                if (!isBlockedState(address.state)) this.saveAddressIfChanged();
            }
        },

        getAddressDataBilling(address) {
            this.billingAddress.addressLine1 = address.street;
            this.billingAddress.addressLine2 = address.address_line2;
            this.billingAddress.city = address.city;
            this.billingAddress.state = address.state;
            this.billingAddress.zip = address.zip;
        },

        // The address form emits on every blur and on each City / ZIP keystroke, so
        // only a complete address that differs from the last one sent is posted.
        async saveAddressIfChanged() {
            const info = this.customerInfo;
            if (!this.validateAddress(info) || !US_ZIP.test(info.zip)) return;
            const key = JSON.stringify([info.addressLine1, info.addressLine2, info.city, info.state, info.zip]);
            if (key === this.savedAddressKey) return;
            this.savedAddressKey = key;
            // A failed save goes out again on the next emit.
            if (!(await this.updateAddress()) && this.savedAddressKey === key) this.savedAddressKey = null;
        },

        async updateAddress() {
            try {
                this.customerInfo.id = this.user?.id || 'guest-' + Date.now();
                await this.$axios.post(`${this.baseUrl}/api/save-address`, this.customerInfo);
                return true;
            } catch (error) {
                console.error('Error updating address:', error);
                // Don't throw error here, as it might block payment flow
                return false;
            }
        },

        validateAddress(address) {
            return address.addressLine1 &&
                address.city &&
                address.state &&
                address.zip;
        },

        // GLP-1 cannot be sold in Louisiana or Mississippi (state law). Runs before every
        // charge: card, Klarna, and Apple Pay / Google Pay / Link, whose wallet billing
        // state is passed in. Shows the refusal and returns true when the sale must stop.
        stopForBlockedState(walletBillingState) {
            const states = [this.customerInfo.state, this.differentShipping ? this.billingAddress.state : '', walletBillingState];
            if (!states.some(isBlockedState)) return false;
            this.paymentError = true;
            this.errorMessage = BLOCKED_STATE_MESSAGE;
            this.submitted = false;
            return true;
        },

        async getStripeToken() {
            if (this.submitted) return; // prevent double-charge on rapid re-click / paint race
            this.submitted = true;
            this.paymentError = false;
            this.checkoutErrorMessage = '';
            if (this.stopForBlockedState()) return false;
            console.log("submitting")
            // Validate shipping address
            if (!this.validateAddress(this.customerInfo)) {
                this.paymentError = true;
                this.errorMessage = "Please enter a complete shipping address.";
                this.submitted = false;
                this.blinkAddress();
                if (window.innerWidth <= 479) { this.$nextTick(() => { document.querySelector('.field-label-5')?.scrollIntoView({ behavior: 'smooth', block: 'center' }); }); }
                return false;
            }

            // Validate billing address if different
            if (this.differentShipping && !this.validateAddress(this.billingAddress)) {
                this.paymentError = true;
                this.errorMessage = "Please enter a complete billing address.";
                this.submitted = false;
                return false;
            }

            // Check terms accepted
            if (!this.termsAccepted) {
                this.paymentError = true;
                this.errorMessage = "Please agree to the terms and conditions.";
                this.submitted = false;
                return false;
            }

            this.errorReason = false;

            try {
                const billingDetails = {
                    name: `${this.user?.first_name || ''} ${this.user?.last_name || ''}`.trim(),
                    email: this.user?.email || '',
                    address: {
                        line1: this.customerInfo.addressLine1,
                        line2: this.customerInfo.addressLine2 || '',
                        city: this.customerInfo.city,
                        state: this.customerInfo.state,
                        postal_code: this.customerInfo.zip,
                        country: 'US',
                    },
                };

                const { paymentMethod, error } = await stripe.createPaymentMethod({
                    type: 'card',
                    card: this.cardNumberElement,
                    billing_details: billingDetails,
                });

                if (error) {
                    this.paymentError = true;
                    this.errorMessage = error.message || 'Invalid card details. Please check your card information.';
                    this.submitted = false;
                    return;
                }

                this.paymentInfo.cardToken = paymentMethod.id;
                this.paymentInfo.paymentMethod = 'card';
                try {
                    this.paymentInfo.cardDetails = {
                        number: `XXXXXXXXXXXX${paymentMethod.card.last4}`,
                        expiration_month: paymentMethod.card.exp_month,
                        expiration_year: paymentMethod.card.exp_year,
                        cardBin: '',
                        cardBrand: paymentMethod.card.brand,
                        cardLast4: paymentMethod.card.last4,
                    };
                    this.paymentInfo.cardLast4 = paymentMethod.card.last4;
                    this.paymentInfo.cardBrand = paymentMethod.card.brand;
                } catch (e) {
                    console.warn('Could not extract card details from paymentMethod', e);
                }
                this.processPayment();
            } catch (error) {
                console.error(error);
                this.paymentError = true;
                this.errorMessage = 'Invalid card details. Please check your card information.';
                this.submitted = false;
            }
        },

        async sendRequest(paymentData) {
            let response = await this.$axios.post(`${this.baseUrl}/api/checkout-stripe`, paymentData, {
                headers: { 'X-Correlation-Id': this.correlationId }
            });
            return response;
        },

        ensureCorrelationId() {
            try {
                if (this.correlationId) return this.correlationId;
                if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
                    this.correlationId = crypto.randomUUID();
                    return this.correlationId;
                }
                this.correlationId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
                    const r = (Math.random() * 16) | 0;
                    const v = c === 'x' ? r : (r & 0x3) | 0x8;
                    return v.toString(16);
                });
                return this.correlationId;
            } catch (e) {
                console.log('correlation id generation failed', e);
                this.correlationId = '';
                return '';
            }
        },

        fireBeacon(url, payload) {
            try {
                if (!url) return;
                const params = new URLSearchParams();
                const data = payload || {};
                Object.keys(data).forEach((k) => {
                    const v = data[k];
                    if (v !== null && v !== undefined && v !== '') {
                        params.append(k, String(v));
                    }
                });
                const body = params.toString();
                if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
                    try {
                        const blob = new Blob([body], { type: 'application/x-www-form-urlencoded' });
                        if (navigator.sendBeacon(url, blob)) return;
                    } catch (_) { /* fall through */ }
                }
                if (typeof fetch === 'function') {
                    fetch(url, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        body,
                        keepalive: true,
                        credentials: 'omit',
                    }).catch(() => {});
                }
            } catch (e) {
                console.log('beacon fire failed', e);
            }
        },

        firePaymentAttemptStart(paymentData) {
            try {
                if (!this.baseUrl) return;
                this.paymentAttemptStartedAt = Date.now();
                this.paymentAttemptNumber = (this.paymentAttemptNumber || 0) + 1;
                this.fireBeacon(`${this.baseUrl}/api/payment-beacon-ping`, {
                    correlation_id: this.correlationId,
                    t: this.paymentAttemptStartedAt,
                });
                this.fireBeacon(`${this.baseUrl}/api/payment-attempt`, {
                    correlation_id: this.correlationId,
                    outcome: 'started',
                    user_id: (this.user && this.user.id) || null,
                    cart_id: (this.$route && this.$route.params && this.$route.params.cart_id) || null,
                    amount: (paymentData && paymentData.amount) || null,
                    currency: 'usd',
                    attempt_number: this.paymentAttemptNumber,
                    status_code: null,
                    error_category: null,
                    tracking_session_id: (paymentData && paymentData.tracking_session_id) || null,
                    page_url: (typeof window !== 'undefined' && window.location && window.location.href) || null,
                    source: this.paymentAttemptSource,
                });
            } catch (e) {
                console.log('start beacon failed', e);
            }
        },

        firePaymentAttemptOutcome(outcome, extras) {
            try {
                if (!this.baseUrl) return;
                const now = Date.now();
                this.fireBeacon(`${this.baseUrl}/api/payment-attempt`, {
                    correlation_id: this.correlationId,
                    outcome,
                    user_id: (this.user && this.user.id) || null,
                    cart_id: (this.$route && this.$route.params && this.$route.params.cart_id) || null,
                    amount: (extras && extras.amount) || null,
                    currency: 'usd',
                    attempt_number: this.paymentAttemptNumber,
                    status_code: (extras && extras.status_code) || null,
                    error_category: (extras && extras.error_category) || null,
                    error_code: (extras && extras.error_code) || null,
                    error_name: (extras && extras.error_name) || null,
                    error_message: (extras && extras.error_message) || null,
                    has_response: (extras && typeof extras.has_response === 'boolean') ? extras.has_response : null,
                    response_content_type: (extras && extras.response_content_type) || null,
                    response_body_preview: (extras && extras.response_body_preview) || null,
                    online: (extras && typeof extras.online === 'boolean') ? extras.online : null,
                    connection_type: (extras && extras.connection_type) || null,
                    duration_ms: this.paymentAttemptStartedAt ? (now - this.paymentAttemptStartedAt) : null,
                    tracking_session_id: (extras && extras.tracking_session_id) || null,
                    page_url: (typeof window !== 'undefined' && window.location && window.location.href) || null,
                    source: this.paymentAttemptSource,
                });
            } catch (e) {
                console.log('outcome beacon failed', e);
            }
        },

        classifyPaymentError(err) {
            try {
                if (!err || !err.response) {
                    if (typeof navigator !== 'undefined' && navigator.onLine === false) return 'offline';
                    if (err && (err.code === 'ECONNABORTED' || err.code === 'ETIMEDOUT')) return 'timeout';
                    if (err && err.message && /timeout/i.test(err.message)) return 'timeout';
                    if (err && err.code === 'ERR_CANCELED') return 'canceled';
                    if (err && err.isAxiosError !== true && !err.request) return 'client_exception';
                    return 'network_error';
                }
                const status = err.response.status;
                if (status === 408) return 'timeout';
                if (status === 429) return 'rate_limited';
                if (status >= 500) return 'server_error';
                if (status === 401 || status === 403) return 'auth';
                if (status === 400 || status === 422) return 'validation';
                if (status === 402) return 'payment_declined';
                return 'unknown';
            } catch (e) {
                return 'unknown';
            }
        },

        collectErrorDiagnostics(err) {
            const details = {
                error_code: null,
                error_name: null,
                error_message: null,
                has_response: null,
                response_content_type: null,
                response_body_preview: null,
                online: null,
                connection_type: null,
            };
            try {
                if (err) {
                    if (err.code) details.error_code = String(err.code);
                    if (err.name) details.error_name = String(err.name);
                    if (err.message) details.error_message = String(err.message).slice(0, 300);
                    if (err.response) {
                        details.has_response = true;
                        try {
                            const ct = err.response.headers && (err.response.headers['content-type'] || err.response.headers['Content-Type']);
                            if (ct) details.response_content_type = String(ct).slice(0, 100);
                        } catch (_) { /* ignore */ }
                        try {
                            let preview = err.response.data;
                            if (preview !== null && preview !== undefined) {
                                if (typeof preview === 'object') preview = JSON.stringify(preview);
                                details.response_body_preview = String(preview).slice(0, 300);
                            }
                        } catch (_) { /* ignore */ }
                    } else {
                        details.has_response = false;
                    }
                }
                if (typeof navigator !== 'undefined') {
                    if (typeof navigator.onLine === 'boolean') details.online = navigator.onLine;
                    const c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
                    if (c && c.effectiveType) details.connection_type = String(c.effectiveType);
                }
            } catch (_) { /* ignore */ }
            return details;
        },

        async payWithKlarna() {
            if (this.submitted) return; // prevent double-charge on rapid re-click / paint race
            this.submitted = true;
            // Refuse to charge without a live plan for the selected term.
            if (!await this.requirePlanId()) return;
            // Fresh idempotency key per Klarna attempt (sent as X-Correlation-Id header below).
            this.correlationId = '';
            this.ensureCorrelationId();
            this.paymentError = false;
            this.checkoutErrorMessage = '';
            if (this.stopForBlockedState()) return;

            if (!this.validateAddress(this.customerInfo)) {
                this.paymentError = true;
                this.errorMessage = 'Please enter a complete shipping address.';
                this.submitted = false;
                this.blinkAddress();
                if (window.innerWidth <= 479) { this.$nextTick(() => { document.querySelector('.field-label-5')?.scrollIntoView({ behavior: 'smooth', block: 'center' }); }); }
                return;
            }
            if (this.differentShipping && !this.validateAddress(this.billingAddress)) {
                this.paymentError = true;
                this.errorMessage = 'Please enter a complete billing address.';
                this.submitted = false;
                return;
            }
            if (this.isPOBox(this.customerInfo.addressLine1)) {
                this.addressError = true;
                this.submitted = false;
                return;
            }

            let klarnaTrackingSessionId = "";
            try {
                klarnaTrackingSessionId = await window.tracking.assertSession();
            } catch (error) {
                if (window.trackingSessionId) {
                    klarnaTrackingSessionId = window.trackingSessionId;
                }
            }

            try {
                const billingAddr = this.differentShipping ? this.billingAddress : this.customerInfo;
                const shippingAddress = {
                    addressLine1: this.customerInfo.addressLine1,
                    addressLine2: this.customerInfo.addressLine2,
                    city: this.customerInfo.city,
                    state: this.customerInfo.state,
                    zip: this.customerInfo.zip,
                };

                // amountInCents already nets out the coupon (getCurrentPrice subtracts it),
                // so subtracting discount again here would apply it twice.
                const chargeAmount = this.amountInCents;

                const response = await this.$axios.post(`${this.baseUrl}/api/create-payment-intent`, {
                    id: this.user?.id || 'guest-' + Date.now(),
                    amount: chargeAmount,
                    payment_method_types: ['klarna'],
                    user_id: this.user?.id || 'guest-' + Date.now(),
                    planId: this.selectedPlanId,
                    payment_terms: this.paymentInfo.payment_terms,
                    couponCode: this.paymentInfo.couponId ? (this.paymentInfo.couponCode || '') : '',
                    couponId: this.paymentInfo.couponId,
                    discount: this.paymentInfo.discount,
                    firstName: this.user?.first_name,
                    lastName: this.user?.last_name,
                    email: this.user?.email,
                    cartTotal: this.orderTotal(),
                    shippingAddress,
                    billingAddress: {
                        addressLine1: billingAddr.addressLine1,
                        addressLine2: billingAddr.addressLine2,
                        city: billingAddr.city,
                        state: billingAddr.state,
                        zip: billingAddr.zip,
                    },
                    cartItems: this.orderCartItems(),
                    mainProductTotal: this.orderTotal(),
                    addonTotal: 0,
                    totalOrderAmount: this.orderTotal(),
                    // Stamped onto the PaymentIntent metadata, which fulfillment reads.
                    ...(this.offerToSend ? { offer: this.offerToSend } : {}),
                    medication: this.getcartItems?.name || '',
                    drug_mode: this.paymentInfo.drug_mode || '',
                    tracking_session_id: klarnaTrackingSessionId,
                }, {
                    headers: { 'X-Correlation-Id': this.correlationId }
                });

                const { clientSecret } = response.data;
                const currentUrl = window.location.origin;
                const cartId = this.$route.params.cart_id;
                const returnUrl = `${currentUrl}/weight-loss-payment/${cartId}/klarna-return`;

                // Snapshot the cart BEFORE redirecting to Klarna. KlarnaReturn.vue is a fresh
                // page load after the redirect and can't see this component's cart, so it reads
                // this back to send cartItems on /api/confirm-klarna-payment (Deepak's spec:
                // [{ id: productObjectId, quantity, price }]). Keyed to this payment intent so a
                // stale snapshot never attaches to another checkout that shares KlarnaReturn.vue.
                try {
                    const snapshotItems = klarnaSnapshotItems(
                        this.getcartItems?.id || this.defaultProduct.id,
                        chargeAmount,
                        this.cartOffer,
                        this.paymentInfo.payment_terms,
                    );
                    sessionStorage.setItem('pending_klarna_cart', JSON.stringify({
                        payment_intent_id: clientSecret.split('_secret')[0],
                        items: snapshotItems,
                    }));
                } catch (e) { /* sessionStorage unavailable — confirm falls back to paymentIntentId only */ }

                const { error } = await stripe.confirmKlarnaPayment(clientSecret, {
                    payment_method: {
                        billing_details: {
                            name: `${this.user?.first_name || ''} ${this.user?.last_name || ''}`.trim(),
                            email: this.user?.email,
                            address: {
                                line1: billingAddr.addressLine1,
                                line2: billingAddr.addressLine2 || '',
                                city: billingAddr.city,
                                state: billingAddr.state,
                                postal_code: billingAddr.zip,
                                country: 'US',
                            },
                        },
                    },
                    return_url: returnUrl,
                });

                if (error) {
                    this.paymentError = true;
                    this.errorMessage = error.message || 'Klarna payment failed. Please try again.';
                    this.submitted = false;
                }
            } catch (error) {
                this.paymentError = true;
                this.errorMessage = error.response?.data?.message || 'Failed to initiate Klarna payment. Please try again.';
                this.submitted = false;
            }
        },

        async processPayment() {
            // Refuse to charge without a live plan for the selected term.
            if (!await this.requirePlanId()) return;

            // Fresh idempotency key per payment attempt. Sent as the X-Correlation-Id
            // header on the charge so the backend's Stripe idempotency key blocks a
            // duplicate of THIS same attempt from creating a second charge.
            this.correlationId = '';
            this.ensureCorrelationId();

            let tracking_session_id = "";
                try{
                    tracking_session_id = await window.tracking.assertSession();
                }catch(error){
                    if(window.trackingSessionId){
                        tracking_session_id = window.trackingSessionId;
                    }
                }
            this.trackingSessionId = tracking_session_id;
            // Fire start beacon as early as possible with best-effort data,
            // so an attempt is always recorded even if paymentData construction throws.
            try {
                let earlyAmount = null;
                try { earlyAmount = this.amountInCents; } catch (_) { /* ignore */ }
                this.firePaymentAttemptStart({ amount: earlyAmount, tracking_session_id });
            } catch (_) { /* ignore */ }

            try {
                // Check required fields for mobile view
                if (this.isMobile) {

                    if (!this.termsAccepted) {
                        this.paymentError = true;
                        this.errorMessage = "Please agree to the terms and conditions.";
                        this.submitted = false;
                        return;
                    }
                }
                try{
                    localStorage.setItem("productName", JSON.stringify(this.getcartItems.name))
                }catch(e){
                    console.log(e)
                }
                this.submitted = true;
                this.paymentError = false;

                // Get user ID from store or use a placeholder for guest checkout
                this.paymentInfo.user_id = this.user?.id || 'guest-' + Date.now();
                this.paymentInfo.id = this.paymentInfo.user_id;
                this.paymentInfo.cartItems = this.orderCartItems();
                this.paymentInfo.planId = this.selectedPlanId;
                this.paymentInfo.medication = this.getcartItems?.name || '';

                // If using mobile view, add phone number
                if (this.isMobile) {
                    this.paymentInfo.phone = this.getPhoneNumber();
                }

                // Order totals describe the selected plan, not one month of the cart item —
                // the store's cartTotal is the product's single-month price and would
                // under-report every 3/6/12-month order.
                const planTotal = this.orderTotal();
                const planTotalNoDiscount = this.orderTotalNoDiscount();

                let paymentData = {
                    ...this.paymentInfo,
                    amount: this.amountInCents,
                    cartTotal: planTotal,
                    cartTotalNoDiscount: planTotalNoDiscount,
                    mainProductTotal: planTotal,
                    addonTotal: 0,
                    totalOrderAmount: planTotal,
                    firstName: this.user?.first_name || '',
                    lastName: this.user?.last_name || '',
                    email: this.user?.email || '',
                    offer: this.offerToSend,
                    billingAddress: this.customerInfo,
                    shippingAddress: this.customerInfo,
                    user_agent: window.navigator.userAgent || 'unknown',
                    ip_address: this.ip_address || 'unknown',
                    tracking_session_id: tracking_session_id
                };

                if (this.differentShipping) {
                    paymentData.billingAddress = this.billingAddress;
                    paymentData.shippingAddress = this.customerInfo;
                }

                const response = await this.sendRequest(paymentData);
                // Drives the purchase event's event_value on the thanks page. Priority
                // review is charged separately and fires its own purchase, so it is
                // deliberately not folded in here.
                let amountCharged = paymentData.amount / 100
                // 3D Secure: the bank's popup for each client secret (utils/bankCheck.js),
                // on the same Stripe instance that made the card and wallet PaymentMethods.
                // Passing it is paid: the backend activates the order from Stripe's webhook.
                const bankCheck = needsBankCheck(response.data)
                    ? await runBankChecks(stripe, response.data.client_secrets)
                    : null;
                if (response.data.status === 'success' || (bankCheck && bankCheck.ok)) {
                        try {
                            if (this.paymentInfo.cardLast4) {
                                localStorage.setItem('rxpros_card_on_file', JSON.stringify({
                                    last4: this.paymentInfo.cardLast4,
                                    brand: this.paymentInfo.cardBrand || '',
                                }));
                            }
                        } catch (e) { console.log(e); }
                        await this.setPrescriptionPreauths(response.data.prescriptionPreauths);
                        await this.saveTrustFrom(this.trustUrl);
                        await this.updateAddress();
                        await this.clearCart();
                        
                        let transactionIdentifier;
                        try{
                            if (response.data.transaction_id) {
                                transactionIdentifier = response.data.transaction_id;
                            } else if (response.data.prescriptionPreauths && response.data.prescriptionPreauths.length > 0) {
                                transactionIdentifier = response.data.prescriptionPreauths[0].transactionId;
                            } else {
                                // Final fallback: customer ID + timestamp for unique identifier
                                transactionIdentifier = `${response.data.customerId}_${Date.now()}`;
                            }
                        }catch(e){
                            console.log(e)
                            transactionIdentifier = `${Date.now()}`;
                        }
                        
                        // Report the order here, where the server has confirmed it — not on
                        // the thanks page. The add-on offer now sits between this point and
                        // that redirect, so a customer who closes the tab at the offer still
                        // counts. The thanks page skips anything already reported.
                        fireOrderPurchase({ amount: amountCharged, transactionId: transactionIdentifier });

                        this.offerFastTrackOrRoute(amountCharged, transactionIdentifier);
                        // keep submitted = true through the redirect (do NOT re-enable on success — prevents redirect-gap double-charge)
                    } else {

                    this.checkoutErrorMessage = bankCheck
                        ? (bankCheck.message || "Payment failed")
                        : shopperMessage(response.data.message, "Payment failed");
                    // Part of the order went through before the bank refused the rest, so
                    // a retry would charge that part again: the button stays locked.
                    this.submitted = !!(bankCheck && bankCheck.confirmed);
                    try {
                        this.firePaymentAttemptOutcome('payment_declined', {
                            amount: paymentData.amount,
                            status_code: 200,
                            error_category: (response.data && response.data.error_category) || 'payment_declined',
                            error_message: response.data && response.data.message,
                            tracking_session_id: paymentData.tracking_session_id,
                        });
                    } catch (_) { /* ignore beacon errors */ }
                }
            } catch (error) {
                this.submitted = false;
                // A backend without the 3D Secure change refuses the card with Stripe's
                // own developer text; the shopper gets this page's line instead.
                this.checkoutErrorMessage = shopperMessage(error.response?.data?.message, "Payment failed");
                try {
                    const errorCategory = this.classifyPaymentError(error);
                    const diagnostics = this.collectErrorDiagnostics(error);
                    this.firePaymentAttemptOutcome(errorCategory, {
                        status_code: (error && error.response && error.response.status) || 0,
                        error_category: errorCategory,
                        error_code: diagnostics.error_code,
                        error_name: diagnostics.error_name,
                        error_message: diagnostics.error_message,
                        has_response: diagnostics.has_response,
                        response_content_type: diagnostics.response_content_type,
                        response_body_preview: diagnostics.response_body_preview,
                        online: diagnostics.online,
                        connection_type: diagnostics.connection_type,
                    });
                } catch (_) { /* ignore beacon errors */ }
            }


        },
        async getIpAddress() {
            try {
                const response = await fetch('https://api.ipify.org?format=json');
                const data = await response.json();
                this.ip_address = data.ip;
                return data.ip;
            } catch (error) {
                console.error('Error getting IP:', error);
            }
        },
        saveTrustFrom(url) {
            try {
                this.$axios.post(`${this.baseUrl}/api/trust-form`, {
                    "user_id": this.user.id,
                    "url": url
                });
            } catch (error) {
                console.log("error saving url trust");
            }
        },

        pushToRoute(amountCharged, transaction_id) {
            try {
                const query = {};
                if (this.paymentInfo.payment_terms !== null) {
                    query.terms = String(this.paymentInfo.payment_terms);
                }
                query.amount = amountCharged;  
                query.trans_id = transaction_id;
                this.$router.push({
                    name: 'prescriptionThanks',
                    query
                });
            } catch (error) {
                console.log(error);
                this.$router.push({
                    name: 'prescriptionThanks'
                });
            }
        },

        // Calculate and format savings text for display
        getSavingsText(value) {
            const monthlyPlanTotal = this.getFirstMonthPrice() + (this.getRegularMonthlyPrice() * (value - 1));
            const prepaidTotal = this.getTotalPrice(value);
            const savings = monthlyPlanTotal - prepaidTotal;
            return `${savings.toFixed(2)} Total Savings`;
        },
    },

    computed: {
        ...mapGetters([
            'user',
            'cartItems',
            'cartTotal',
            'cartDiscount',
            'cartTotalNoDiscount',
            'isAuthenticated'
        ]),

        // The offer link's free NAD+ applies on the plan lengths its offer runs on
        // (3/6/12 months): a monthly plan leaves it off, a longer plan brings it back.
        offerLineActive() {
            return isOfferActive(this.cartOffer, this.paymentInfo.payment_terms);
        },

        // The offer slug travels only with its line (utils/cartOffer.js).
        offerToSend() {
            return offerSlug(this.cartOffer, this.paymentInfo.payment_terms, this.offer);
        },

        getPlanPoints() {
            if (this.paymentInfo.payment_terms >= 3) {

                const monthlyPlanTotal = this.getFirstMonthPrice() + (this.getRegularMonthlyPrice() * (this.paymentInfo.payment_terms - 1));
                const prepaidTotal = this.getTotalPrice(this.paymentInfo.payment_terms);
                const savings = monthlyPlanTotal - prepaidTotal;
                const savingsPercent = ((savings / monthlyPlanTotal) * 100).toFixed(0);

                return [{
                        "header": `$${(savings / this.paymentInfo.payment_terms).toFixed(0)} a month savings!`,
                        "sub_header": `You will save $${(savings / this.paymentInfo.payment_terms).toFixed(0)} a month paying for ${this.paymentInfo.payment_terms} months up front (${savings.toFixed(0)} Total Savings) vs. our monthly installment plan.`
                    },
                    {
                        "header": `Save up to $${savingsPercent}%`,
                        "sub_header": `You will save big by paying for our ${this.paymentInfo.payment_terms} month program up front.`
                    },
                    {
                        "header": `${this.paymentInfo.payment_terms} Month Supply Program`,
                        "sub_header": `You'll receive a ${this.paymentInfo.payment_terms}-month supply of medication, billed ${this.getBillingFrequency()}. If you cancel before completing the full term, an early termination fee may apply.`
                    }
                ];
            }

            // Monthly plan points
            return [
                {
                    "header": `$${this.getRegularMonthlyPrice().toFixed(2)} per month`,
                    "sub_header": `Paid monthly with 3 month commitment. We send 3 month's worth of medication up front. Zero interest. No credit checks. All dosages.`
                }
            ];
        },

        selectedPlanId() {
            // Plan ObjectId for the selected term — the backend prices the charge off this.
            // Empty when the live plan hasn't loaded; the legacy sema_/tirz_ slug is
            // deliberately NOT used as a fallback, so a stale identifier can never price
            // a charge. requirePlanId refuses the payment rather than let the backend
            // fall back to its higher price.
            const plan = this.apiPlans[this.paymentInfo.payment_terms];
            return plan ? plan.id : '';
        },

        getSupplyDuration() {
            return this.paymentTermLabels[this.paymentInfo.payment_terms].supplyDuration;
        },

        getImage() {
            return this.getcartItems?.image || `${this.assetPath}/1.webp`;
        },

        getcartItems() {
            
            return this.cartItems && this.cartItems.length > 0 ?
                this.cartItems[0] :
                this.defaultProduct;
        },

        isMobile() {
            return detectMobile();
        },

        isLoggedin() {
            return this.isAuthenticated;
        },

        amountInCents() {
            return Math.round(this.getCurrentPrice() * 100);
        },

        // What the customer sees as their total.
        displayTotal() {
            return parseFloat(this.getCurrentPrice().toFixed(2));
        },

        finalTotal() {
            if (this.couponApplied) {
                return this.cartTotalNoDiscount - this.paymentInfo.discount;
            }
            return this.cartTotal;
        },

        getDiscount() {
            if (this.couponApplied) {
                return this.paymentInfo.discount;
            }
            return this.cartDiscount;
        }
    }
}
</script>

<style scoped>
/* Plan badges — Popular / Recommended / Huge Savings */
.plan-box-link {
    position: relative;
    margin-bottom: 16px;
}
.plan-badge {
    position: absolute;
    top: -13px;
    left: 18px;
    z-index: 2;
    background-color: #d7fff0;
    color: #000;
    font-family: var(--satoshi, 'Satoshi', sans-serif);
    font-size: 10px;
    font-weight: 700;
    line-height: 1;
    padding: 6px 11px;
    border-radius: 999px;
    letter-spacing: 0.3px;
    text-transform: uppercase;
    white-space: nowrap;
    pointer-events: none;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}
.huge-savings-btn {
    display: inline-block;
    margin-top: 3px;
    margin-bottom: 6px;
    background-color: #00c042;
    color: #fff;
    font-family: var(--satoshi, 'Satoshi', sans-serif);
    font-size: 8px;
    font-weight: 700;
    line-height: 1;
    letter-spacing: 0.3px;
    text-transform: uppercase;
    padding: 4px 8px;
    border-radius: 4px;
    white-space: nowrap;
    pointer-events: none;
}
/* Stack price column vertically inside the 12-month card so HUGE SAVINGS sits below the price */
.plan-box-link._12mo .planbox_pricebox._6mo {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 2px;
}

/* Error Toast */
.error-toast {
    position: fixed;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    width: 90%;
    max-width: 400px;
    background: #dc2626;
    color: #fff;
    padding: 16px 20px;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    z-index: 99999999;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    animation: toast-in 0.3s ease, toast-out 0.3s ease 4.7s;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
}
.error-toast span {
    flex: 1 1 auto;
    min-width: 0;
    overflow-wrap: break-word;
    word-break: break-word;
}
.toast-close {
    background: none;
    border: none;
    color: #fff;
    font-size: 22px;
    cursor: pointer;
    padding: 0;
    line-height: 1;
    opacity: 0.8;
    flex-shrink: 0;
}
.toast-close:hover {
    opacity: 1;
}
@keyframes toast-in {
    from { opacity: 0; transform: translateX(-50%) translateY(-20px); }
    to { opacity: 1; transform: translateX(-50%) translateY(0); }
}
@keyframes toast-out {
    from { opacity: 1; transform: translateX(-50%) translateY(0); }
    to { opacity: 0; transform: translateX(-50%) translateY(-20px); }
}

/* Address Blink */
.address-highlight :deep(input) {
    animation: blink-red 0.5s ease 3;
}
@keyframes blink-red {
    0%, 100% { border-color: inherit; }
    50% { border-color: #dc2626; box-shadow: 0 0 0 2px rgba(220, 38, 38, 0.3); }
}

/* Express Checkout & Klarna */
.express-checkout-section {
    margin-bottom: 16px;
}

.express-checkout-box {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 16px;
}

.payment-request-btn-container {
    min-height: 48px;
}

.divider {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
}

.divider-line {
    flex: 1;
    height: 1px;
    min-width: 0;
    background: #d8dbe0;
}

.divider span {
    font-size: 14px;
    color: #6b7280;
    font-weight: 500;
}

/* Klarna Button */
.klarna-btn {
    width: 100%;
    background: #ffb3c7;
    color: #0b0b0b;
    border: none;
    border-radius: 4px;
    padding: 12px 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: all 0.2s;
    font-family: inherit;
    height: 48px;
}

.klarna-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(255, 179, 199, 0.5);
}

.klarna-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
}

.klarna-btn-text {
    font-size: 16px;
    font-weight: 600;
}

.klarna-logo {
    height: 18px;
    width: auto;
}

/* Stripe Card Elements */
.ns-card-element {
    border: 1px solid #d8dbe0;
    border-radius: 8px;
    padding: 14px;
    font-size: 15px;
    background: white;
    min-height: 48px;
    margin-bottom: 10px;
}

.form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
}

.form-group label {
    display: block;
    font-size: 14px;
    font-weight: 500;
    color: #374151;
    margin-bottom: 6px;
}

.active-one{
    background-color: var(--dark-bluegreen);
    background-image: none;
    border: 3px solid #00ffc8;
    color: #fff;
}
.active-me{
    background-color: var(--dark-bluegreen);
    background-image: none;
    border: 3px solid #00ffc8;
    color: #fff;
}

.active-six {
    background-color: var(--dark-bluegreen);
    background-image: none;
    border: 3px solid #00ffc8;
    color: #fff;
}
/* Checkout Error Banner */
.checkout-error-banner {
    background: #fef2f2;
    border: 1px solid #fca5a5;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 16px;
}
.checkout-error-banner-content {
    display: flex;
    gap: 12px;
    align-items: flex-start;
}
.checkout-error-icon {
    font-size: 20px;
    line-height: 1;
    flex-shrink: 0;
}
.checkout-error-text {
    flex: 1 1 auto;
    min-width: 0;
}
.checkout-error-heading {
    font-weight: 700;
    color: #991b1b;
    margin-bottom: 4px;
}
.checkout-error-message {
    color: #991b1b;
    margin-bottom: 4px;
    font-size: 14px;
    overflow-wrap: break-word;
    word-break: break-word;
}
.checkout-error-helper {
    color: #b91c1c;
    font-size: 13px;
    overflow-wrap: break-word;
    word-break: break-word;
}

.myspanret{
    font-weight: bold;
    font-size: 22px;
}
@media screen and (max-width: 479px) {
    .text-field-58.new {
        color: #000;
        height: 48px;
    }
    .text-field-7.new{
        color: #000;
        height: 48px;
    }
    .myclsforse {
        font-size: 20px;
    }
    .express-checkout-box {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 12px;
        padding: 16px;
        align-items: stretch;
    }
    .payment-request-btn-container {
        min-height: 48px;
    }
    .payment-request-btn-container:only-child {
        grid-column: 1 / -1;
    }
    .klarna-btn {
        flex-direction: column;
        padding: 4px 6px;
        gap: 2px;
        height: 48px;
        margin-top: 0;
    }
    .klarna-btn:only-child,
    .express-checkout-box.single-option .klarna-btn {
        grid-column: 1 / -1;
    }
    .klarna-btn-text {
        font-size: 11px;
        white-space: nowrap;
    }
    .klarna-logo {
        height: 16px;
    }
}

.pe-label-7x {
    font-weight: 350 !important;
    color: #4a4a57 !important;
    font-size: 0.9rem !important;
    line-height: 1.15 !important;
    margin-bottom: 4px !important;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;
}
@media screen and (max-width: 991px) {
    .pe-label-7x {
        font-size: 16px !important;
        color: #000 !important;
    }
}

.subscription-agreement {
    margin-top: 12px;
    margin-bottom: 10px;
}
.subscription-agreement p {
    margin: 0 0 10px;
}
.subscription-agreement p:last-child {
    margin-bottom: 0;
}
</style>
